import { gsap } from "gsap";
import React, { useRef, useState } from 'react';



const SVGBg = React.forwardRef((props, ref:any) => { 
    return (
      <g {...props} ref={ref}>
        <path
          d="M404.18 462.38H412.35V493.65999999999997H404.18z"
          className="st0"
        ></path>
        <path d="M404.18 430.3H412.35V461.52H404.18z" className="st0"></path>
        <path
          d="M404.18 398.12H412.35V429.34000000000003H404.18z"
          className="st0"
        ></path>
        <path d="M404.18 494.51H412.35V525.79H404.18z" className="st0"></path>
        <path
          d="M404.18 397.26h8.17v-31.28h-9.79a8.191 8.191 0 011.62 4.88v26.4z"
          className="st0"
        ></path>
        <path d="M274.86 494.51H285.37V525.79H274.86z" className="st0"></path>
        <path
          d="M205.42 494.62h13.4v-.11h-26.9v31.28h5.28v-22.94c0-4.55 3.68-8.23 8.22-8.23zM228.58 502.84v22.94h13.45V494.5h-22.47v.11h.8c4.54.01 8.22 3.69 8.22 8.23zM330.16 398.12v.42c.1-.15.21-.29.32-.42h-.32zM265.2 467.86a8.22 8.22 0 018.22 8.22v17.58h.7v-31.28h-26.9v6.07a8.27 8.27 0 013.04-.59h14.94zM401.84 365.13h10.51v-31.28h-26.9v28.79h10.51c2.31.01 4.39.96 5.88 2.49z"
          className="st0"
        ></path>
        <path
          d="M274.86 462.38H285.37V493.65999999999997H274.86z"
          className="st0"
        ></path>
        <path
          d="M246.47 468.79v-6.41h-26.9v31.28h22.47v-17.58a8.176 8.176 0 014.43-7.29zM381.02 362.65h3.69v-28.79h-26.9v31.28h17.33a8.144 8.144 0 015.88-2.49z"
          className="st0"
        ></path>
        <path
          d="M316.76 462.38H328.71V493.65999999999997H316.76z"
          className="st0"
        ></path>
        <path
          d="M329.41 399.88v-1.77h-26.9v31.22h26.2v-26.15c0-1.17.25-2.29.7-3.3zM351.88 394.97c1.97 0 3.77.69 5.18 1.84v-30.83h-26.9v31.28h1.09c1.48-1.41 3.47-2.29 5.68-2.29h14.95zM292.24 430.3h-17.37v31.22h10.51V438.4c-.01-4.08 2.96-7.45 6.86-8.1zM316.76 438.4v23.13h11.95V430.3h-18.82c3.9.65 6.87 4.02 6.87 8.1z"
          className="st0"
        ></path>
        <path d="M316.76 494.51H328.71V525.79H316.76z" className="st0"></path>
        <path
          d="M374.42 365.98h-16.61v31.28h14.99v-26.39c0-1.83.6-3.52 1.62-4.89z"
          className="st0"
        ></path>
        <path
          d="M360.09 494.51H372.78999999999996V525.79H360.09z"
          className="st0"
        ></path>
        <path
          d="M360.09 462.38H372.78999999999996V493.65999999999997H360.09z"
          className="st0"
        ></path>
        <path
          d="M360.09 429.34h12.7v-31.22h-14.47a8.19 8.19 0 011.76 5.08v26.14z"
          className="st0"
        ></path>
        <path
          d="M360.09 430.3H372.78999999999996V461.52H360.09z"
          className="st0"
        ></path>
        <path
          d="M495.15 301.72h-5.98a8.187 8.187 0 013.19 6.49V333h11.95v-31.28h-9.16z"
          className="st0"
        ></path>
        <path
          d="M448.27 462.38H460.96999999999997V493.65999999999997H448.27z"
          className="st0"
        ></path>
        <path d="M330.16 301.72H357.06V333H330.16z" className="st0"></path>
        <path
          d="M448.27 430.3H460.96999999999997V461.52H448.27z"
          className="st0"
        ></path>
        <path d="M273.42 494.51H274.12V525.79H273.42z" className="st0"></path>
        <path
          d="M495.15 333.85L492.35 333.85 492.35 365.13 495.15 365.13 504.31 365.13 504.31 333.85z"
          className="st0"
        ></path>
        <path
          d="M495.15 365.98L492.35 365.98 492.35 397.26 495.15 397.26 504.31 397.26 504.31 365.98z"
          className="st0"
        ></path>
        <path
          d="M495.15 494.51L492.35 494.51 492.35 525.78 495.15 525.78 504.31 525.78 504.31 494.51z"
          className="st0"
        ></path>
        <path
          d="M495.15 462.38L492.35 462.38 492.35 493.65 495.15 493.65 504.31 493.65 504.31 462.38z"
          className="st0"
        ></path>
        <path
          d="M492.35 430.3L492.35 461.52 495.15 461.52 504.31 461.52 504.31 430.3z"
          className="st0"
        ></path>
        <path
          d="M495.15 398.12L492.35 398.12 492.35 429.34 504.31 429.34 504.31 398.12z"
          className="st0"
        ></path>
        <path
          d="M448.27 365.98H460.96999999999997V397.26H448.27z"
          className="st0"
        ></path>
        <path
          d="M448.27 398.12H460.96999999999997V429.34000000000003H448.27z"
          className="st0"
        ></path>
        <path
          d="M440.75 332.79c.42.04.84.11 1.24.2h18.99v-24.78c0-2.64 1.25-4.99 3.19-6.49h-23.41v31.07zM413.1 301.72V333h10.07c.62-.15 1.27-.24 1.94-.24H440v-31.04h-26.9zM163.53 525.71v-31.2h-26.9v31.28h24.42c.34-.04.68-.07 1.03-.07h1.45zM413.1 365.13h3.78v-24.15c0-3.05 1.67-5.71 4.13-7.13h-7.92v31.28zM178.06 525.78h13.12V494.5h-26.9v31.2h12.75c.35.01.69.04 1.03.08z"
          className="st0"
        ></path>
        <path
          d="M413.1 462.38H416.88V493.65999999999997H413.1z"
          className="st0"
        ></path>
        <path d="M413.1 494.51H416.88V525.79H413.1z" className="st0"></path>
        <path d="M413.1 365.98H416.88V397.26H413.1z" className="st0"></path>
        <path
          d="M448.27 340.98v24.15h12.7v-31.28h-16.84c2.47 1.42 4.14 4.08 4.14 7.13z"
          className="st0"
        ></path>
        <path
          d="M413.1 398.12H416.88V429.34000000000003H413.1z"
          className="st0"
        ></path>
        <path d="M413.1 430.3H416.88V461.52H413.1z" className="st0"></path>
        <path
          d="M448.27 494.51H460.96999999999997V525.79H448.27z"
          className="st0"
        ></path>
        <path d="M136.63 301.72H163.53V333H136.63z" className="st0"></path>
        <path
          d="M164.27 301.72H191.17000000000002V333H164.27z"
          className="st0"
        ></path>
        <path d="M136.63 333.85H163.53V365.13H136.63z" className="st0"></path>
        <path d="M136.63 365.98H163.53V397.26H136.63z" className="st0"></path>
        <path
          d="M136.63 398.12H163.53V429.34000000000003H136.63z"
          className="st0"
        ></path>
        <path d="M247.22 365.98H274.12V397.26H247.22z" className="st0"></path>
        <path
          d="M302.51 333.85H329.40999999999997V365.13H302.51z"
          className="st0"
        ></path>
        <path d="M274.86 365.98H301.76V397.26H274.86z" className="st0"></path>
        <path d="M274.86 333.85H301.76V365.13H274.86z" className="st0"></path>
        <path d="M136.63 430.3H163.53V461.52H136.63z" className="st0"></path>
        <path d="M274.86 301.72H301.76V333H274.86z" className="st0"></path>
        <path d="M247.22 301.72H274.12V333H247.22z" className="st0"></path>
        <path d="M219.57 301.72H246.47V333H219.57z" className="st0"></path>
        <path d="M330.16 333.85H357.06V365.13H330.16z" className="st0"></path>
        <path
          d="M302.51 365.98H329.40999999999997V397.26H302.51z"
          className="st0"
        ></path>
        <path d="M357.81 301.72H384.71V333H357.81z" className="st0"></path>
        <path
          d="M385.45 301.72H412.34999999999997V333H385.45z"
          className="st0"
        ></path>
        <path
          d="M136.63 462.38H163.53V493.65999999999997H136.63z"
          className="st0"
        ></path>
        <path
          d="M191.92 462.38H218.82V493.65999999999997H191.92z"
          className="st0"
        ></path>
        <path
          d="M274.86 398.12H301.76V429.34000000000003H274.86z"
          className="st0"
        ></path>
        <path
          d="M164.27 462.38H191.17000000000002V493.65999999999997H164.27z"
          className="st0"
        ></path>
        <path d="M247.22 430.3H274.12V461.52H247.22z" className="st0"></path>
        <path d="M219.57 430.3H246.47V461.52H219.57z" className="st0"></path>
        <path d="M191.92 301.72H218.82V333H191.92z" className="st0"></path>
        <path d="M191.92 365.98H218.82V397.26H191.92z" className="st0"></path>
        <path d="M191.92 333.85H218.82V365.13H191.92z" className="st0"></path>
        <path
          d="M247.22 398.12H274.12V429.34000000000003H247.22z"
          className="st0"
        ></path>
        <path
          d="M164.27 365.98H191.17000000000002V397.26H164.27z"
          className="st0"
        ></path>
        <path
          d="M302.51 301.72H329.40999999999997V333H302.51z"
          className="st0"
        ></path>
        <path
          d="M164.27 398.12H191.17000000000002V429.34000000000003H164.27z"
          className="st0"
        ></path>
        <path d="M219.57 333.85H246.47V365.13H219.57z" className="st0"></path>
        <path d="M247.22 333.85H274.12V365.13H247.22z" className="st0"></path>
        <path d="M219.57 365.98H246.47V397.26H219.57z" className="st0"></path>
        <path
          d="M164.27 333.85H191.17000000000002V365.13H164.27z"
          className="st0"
        ></path>
        <path
          d="M191.92 398.12H218.82V429.34000000000003H191.92z"
          className="st0"
        ></path>
        <path
          d="M164.27 430.3H191.17000000000002V461.52H164.27z"
          className="st0"
        ></path>
        <path d="M191.92 430.3H218.82V461.52H191.92z" className="st0"></path>
        <path
          d="M219.57 398.12H246.47V429.34000000000003H219.57z"
          className="st0"
        ></path>
        <path
          d="M536.01 248.33h-421c-3.71 0-6.73 3.01-6.73 6.73v15.17h434.46v-15.17c0-3.72-3.02-6.73-6.73-6.73zm-406.19 10.95c0 1.67-1.35 3.02-3.02 3.02s-3.02-1.35-3.02-3.02 1.35-3.02 3.02-3.02 3.02 1.35 3.02 3.02c0-.01 0-.01 0 0zm11.72 0c0 1.67-1.35 3.02-3.02 3.02s-3.02-1.35-3.02-3.02 1.35-3.02 3.02-3.02 3.02 1.35 3.02 3.02c0-.01 0-.01 0 0zm11.72 0c0 1.67-1.35 3.02-3.02 3.02s-3.02-1.35-3.02-3.02 1.35-3.02 3.02-3.02 3.02 1.35 3.02 3.02c0-.01 0-.01 0 0z"
          className="st1"
        ></path>
        <path
          d="M126.81 256.26c-1.67 0-3.02 1.35-3.02 3.02s1.35 3.02 3.02 3.02 3.02-1.35 3.02-3.02v-.01a3.028 3.028 0 00-3.02-3.01zM138.53 256.26c-1.67 0-3.02 1.35-3.02 3.02s1.35 3.02 3.02 3.02 3.02-1.35 3.02-3.02v-.01a3.028 3.028 0 00-3.02-3.01zM150.24 256.26c-1.67 0-3.02 1.35-3.02 3.02s1.35 3.02 3.02 3.02 3.02-1.35 3.02-3.02v-.01c0-1.66-1.35-3.01-3.02-3.01z"
          className="st2"
        ></path>
        <path
          d="M468.39 271.48h-.75v28.67c.25-.05.49-.09.75-.11v-28.56z"
          className="st1"
        ></path>
        <linearGradient
          x1="-528.731"
          x2="-529.105"
          y1="790.978"
          y2="791.515"
          gradientTransform="matrix(0 1.144 517.737 0 -409427.469 906.191)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0" stopColor="#FFF" stopOpacity="0.251"></stop>
          <stop offset="1" stopColor="#FFF"></stop>
        </linearGradient>
        <path d="M108.28 300.87H108.98V301.72H108.28z" className="st3"></path>
        <linearGradient
          id="SVGID_00000077313204138188480540000000331824974915137460_"
          x1="-538.232"
          x2="-538.606"
          y1="790.978"
          y2="791.515"
          gradientTransform="matrix(0 1.144 517.737 0 -409427.469 949.191)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0" stopColor="#FFF" stopOpacity="0.251"></stop>
          <stop offset="1" stopColor="#FFF"></stop>
        </linearGradient>
        <path
          fill="url(#SVGID_00000077313204138188480540000000331824974915137460_)"
          d="M108.28 333H108.98V333.85H108.28z"
        ></path>
        <linearGradient
          id="SVGID_00000003082167810954712190000018413019786885469335_"
          x1="-547.733"
          x2="-548.107"
          y1="790.978"
          y2="791.515"
          gradientTransform="matrix(0 1.144 517.737 0 -409427.469 992.191)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0" stopColor="#FFF" stopOpacity="0.251"></stop>
          <stop offset="1" stopColor="#FFF"></stop>
        </linearGradient>
        <path
          fill="url(#SVGID_00000003082167810954712190000018413019786885469335_)"
          d="M108.28 365.13H108.98V365.98H108.28z"
        ></path>
        <linearGradient
          id="SVGID_00000047750684586506789740000004318709496196257931_"
          x1="-557.235"
          x2="-557.608"
          y1="790.978"
          y2="791.515"
          gradientTransform="matrix(0 1.144 517.737 0 -409427.469 1035.191)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0" stopColor="#FFF" stopOpacity="0.251"></stop>
          <stop offset="1" stopColor="#FFF"></stop>
        </linearGradient>
        <path
          fill="url(#SVGID_00000047750684586506789740000004318709496196257931_)"
          d="M108.28 397.26H108.98V398.11H108.28z"
        ></path>
        <linearGradient
          id="SVGID_00000169520856733995352740000005413795394537325987_"
          x1="-576.237"
          x2="-576.61"
          y1="790.978"
          y2="791.515"
          gradientTransform="matrix(0 1.144 517.737 0 -409427.469 1121.191)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0" stopColor="#FFF" stopOpacity="0.251"></stop>
          <stop offset="1" stopColor="#FFF"></stop>
        </linearGradient>
        <path
          fill="url(#SVGID_00000169520856733995352740000005413795394537325987_)"
          d="M108.28 461.52H108.98V462.37H108.28z"
        ></path>
        <linearGradient
          id="SVGID_00000093890863841804026800000016292892670940791197_"
          x1="-585.738"
          x2="-586.112"
          y1="790.978"
          y2="791.515"
          gradientTransform="matrix(0 1.144 517.737 0 -409427.469 1164.191)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0" stopColor="#FFF" stopOpacity="0.251"></stop>
          <stop offset="1" stopColor="#FFF"></stop>
        </linearGradient>
        <path
          fill="url(#SVGID_00000093890863841804026800000016292892670940791197_)"
          d="M108.28 493.65H108.98V494.5H108.28z"
        ></path>
        <linearGradient
          id="SVGID_00000060713896918001628400000005998819215172049338_"
          x1="-595.239"
          x2="-595.613"
          y1="790.978"
          y2="791.515"
          gradientTransform="matrix(0 1.144 517.737 0 -409427.469 1207.191)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0" stopColor="#FFF" stopOpacity="0.251"></stop>
          <stop offset="1" stopColor="#FFF"></stop>
        </linearGradient>
        <path
          fill="url(#SVGID_00000060713896918001628400000005998819215172049338_)"
          d="M108.28 525.78H108.98V526.63H108.28z"
        ></path>
        <path d="M535.69 300.87H542.73V301.72H535.69z" className="st1"></path>
        <path
          d="M495.15 301.72h9.16v-.85h-16.5c.48.24.94.53 1.36.85h5.98z"
          className="st1"
        ></path>
        <path d="M535.69 333H542.73V333.85H535.69z" className="st1"></path>
        <path
          d="M495.15 333L492.35 333 492.35 333.85 495.15 333.85 504.31 333.85 504.31 333z"
          className="st1"
        ></path>
        <path
          d="M444.13 333.85h16.84V333h-18.99c.77.18 1.49.47 2.15.85z"
          className="st1"
        ></path>
        <path
          d="M495.15 365.13L492.35 365.13 492.35 365.98 495.15 365.98 504.31 365.98 504.31 365.13z"
          className="st1"
        ></path>
        <path d="M535.69 365.13H542.73V365.98H535.69z" className="st1"></path>
        <path
          d="M448.27 365.13H460.96999999999997V365.98H448.27z"
          className="st1"
        ></path>
        <path
          d="M495.15 397.26L492.35 397.26 492.35 398.12 495.15 398.12 504.31 398.12 504.31 397.26z"
          className="st1"
        ></path>
        <path d="M535.69 397.26H542.73V398.11H535.69z" className="st1"></path>
        <path
          d="M448.27 397.26H460.96999999999997V398.11H448.27z"
          className="st1"
        ></path>
        <path
          d="M535.69 429.34H542.73V430.29999999999995H535.69z"
          className="st1"
        ></path>
        <path
          d="M492.35 429.34H504.3V430.29999999999995H492.35z"
          className="st1"
        ></path>
        <path
          d="M360.09 429.34H372.78999999999996V430.29999999999995H360.09z"
          className="st1"
        ></path>
        <path
          d="M448.27 429.34H460.96999999999997V430.29999999999995H448.27z"
          className="st1"
        ></path>
        <path d="M535.69 461.52H542.73V462.37H535.69z" className="st1"></path>
        <path
          d="M495.15 461.52L492.35 461.52 492.35 462.38 495.15 462.38 504.31 462.38 504.31 461.52z"
          className="st1"
        ></path>
        <path
          d="M360.09 461.52H372.78999999999996V462.37H360.09z"
          className="st1"
        ></path>
        <path
          d="M448.27 461.52H460.96999999999997V462.37H448.27z"
          className="st1"
        ></path>
        <path d="M316.76 461.52H328.71V462.37H316.76z" className="st1"></path>
        <path d="M535.69 493.65H542.73V494.5H535.69z" className="st1"></path>
        <path
          d="M495.15 493.65L492.35 493.65 492.35 494.51 495.15 494.51 504.31 494.51 504.31 493.65z"
          className="st1"
        ></path>
        <path d="M316.76 493.65H328.71V494.5H316.76z" className="st1"></path>
        <path
          d="M448.27 493.65H460.96999999999997V494.5H448.27z"
          className="st1"
        ></path>
        <path
          d="M360.09 493.65H372.78999999999996V494.5H360.09z"
          className="st1"
        ></path>
        <path d="M535.69 525.78H542.73V526.63H535.69z" className="st1"></path>
        <path
          d="M495.15 525.78L492.35 525.78 492.35 526.64 495.15 526.64 504.31 526.64 504.31 525.78z"
          className="st1"
        ></path>
        <path
          d="M413.1 525.78V494.5h3.78v-.85h-3.78v-31.28h3.78v-.85h-3.78V430.3h3.78v-.96h-3.78v-31.22h3.78v-.85h-3.78v-31.28h3.78v-.85h-3.78v-31.28h7.92a8.04 8.04 0 012.15-.85H413.1v-31.28H440v31.04h.05c.24 0 .47.02.7.04v-31.07h23.41c.42-.33.88-.61 1.36-.85h-24.77V271.5H440v29.39h-26.9V271.5h-.75v29.39h-26.9V271.5h-.75v29.39h-26.9V271.5h-.75v29.39h-26.9V271.5h-.75v29.39h-26.9V271.5h-.75v29.39h-26.9V271.5h-.75v29.39h-26.9V271.5h-.75v29.39h-26.9V271.5h-.75v29.39h-26.9V271.5h-.75v29.39h-26.9V271.5h-.75v29.39h-26.9V271.5h-.75v29.39h-26.9v.85h26.9V333h-26.9v.85h26.9v31.28h-26.9v.85h26.9v31.28h-26.9v.85h26.9v31.22h-27.6v.96h27.6v31.22h-26.9v.85h26.9v31.28h-26.9v.85h26.9v31.28h-26.9v.85h26.9v16.81c.26.1.5.21.75.33v-17.14h21.67c.84-.44 1.77-.73 2.75-.85H136.6v-31.28h26.9v31.2h.75v-31.2h26.9v31.28h-13.12c.98.12 1.91.42 2.75.85h10.37v24.3h.75v-24.3h5.28v-.85h-5.28v-31.28h26.9v.11h.75v-.11h22.47v-.85h-22.47v-31.28h26.9v6.41c.24-.13.49-.24.75-.34v-6.07h26.9v31.28h-.7v.85h.7v31.28h-.7v.85h.7v24.3h.75v-24.3h10.51v-.85h-10.51v-31.28h10.51v-.85h-10.51v-31.28h10.51v-.85h-10.51V430.3h17.37c.44-.07.89-.12 1.35-.12h14.94c.46 0 .91.05 1.35.12h18.82v-.96h-26.2v-31.22h26.9v1.77c.21-.47.46-.92.75-1.34v-.42h.32c.24-.3.5-.59.78-.85h-1.09V366h26.9v30.83c.47.38.9.82 1.27 1.3h14.47v-.85h-14.99V366h16.61c.22-.3.46-.59.72-.85h-17.33v-31.28h26.9v28.79h.75v-28.79h26.9v31.28h-10.51c.26.27.5.55.72.85h9.79v31.28h-8.17v.85h8.17v31.22h-8.17v.96h8.17v31.22h-8.17v.85h8.17v31.28h-8.17v.85h8.17v31.28h-8.17v.85h8.17v24.3h.75v-24.3h3.78v-.85h-3.77zm-56.04-224.06V333h-26.9v-31.28h26.9zm-27.65 0V333h-26.9v-31.28h26.9zm-82.94 63.41h-26.9v-31.28h26.9v31.28zm.75-31.28h26.9v31.28h-26.9v-31.28zm-27.65 32.13h26.9v31.28h-26.9v-31.28zm-.75 31.28h-26.9v-31.28h26.9v31.28zm0-32.13h-26.9v-31.28h26.9v31.28zm-27.65 0h-26.9v-31.28h26.9v31.28zm0 .85v31.28h-26.9v-31.28h26.9zm0 32.14v31.22h-26.9v-31.22h26.9zm0 32.18v31.22h-26.9V430.3h26.9zm.75 0h26.9v31.22h-26.9V430.3zm0-.96v-31.22h26.9v31.22h-26.9zm27.65-31.22h26.9v31.22h-26.9v-31.22zm27.65 0h26.9v31.22h-26.9v-31.22zm0-.86v-31.28h26.9v31.28h-26.9zm27.64-31.28h26.9v31.28h-26.9v-31.28zm0-.85v-31.28h26.9v31.28h-26.9zm27.65-31.28h26.9v31.28h-26.9v-31.28zm-.75-32.13V333h-26.9v-31.28h26.9zm-27.64 0V333h-26.9v-31.28h26.9zm-27.65 0V333h-26.9v-31.28h26.9zm-27.65 0V333h-26.9v-31.28h26.9zm-27.65 0V333h-26.9v-31.28h26.9zm-54.54 0h26.9V333h-26.9v-31.28zm0 32.13h26.9v31.28h-26.9v-31.28zm0 32.13h26.9v31.28h-26.9v-31.28zm0 32.14h26.9v31.22h-26.9v-31.22zm0 32.18h26.9v31.22h-26.9V430.3zm0 63.35v-31.28h26.9v31.28h-26.9zm27.64 0v-31.28h26.9v31.28h-26.9zm54.55 0h-26.9v-31.28h26.9v31.28zm.75-32.13V430.3h26.9v31.22h-26.9zm54.55 0h-26.9V430.3h26.9v31.22zm27.64-32.18h-26.9v-31.22h26.9v31.22zm27.65-32.08h-26.9v-31.28h26.9v31.28zm27.65-32.13h-26.9v-31.28h26.9v31.28zm.75-32.13v-31.28h26.9V333h-26.9zm27.64 0v-31.28h26.9V333h-26.9z"
          className="st1"
        ></path>
        <path
          d="M448.27 525.78H460.96999999999997V526.63H448.27z"
          className="st1"
        ></path>
        <path
          d="M360.09 525.78H372.78999999999996V526.63H360.09z"
          className="st1"
        ></path>
        <path d="M228.58 525.78H242.03V526.63H228.58z" className="st1"></path>
        <path d="M316.76 525.78H328.71V526.63H316.76z" className="st1"></path>
        <path
          d="M273.42 494.51v-18.43a8.22 8.22 0 00-8.22-8.22h-14.94c-1.07 0-2.1.21-3.04.59-.26.1-.5.22-.75.34a8.217 8.217 0 00-4.43 7.29v76.47h31.38V494.51zM228.58 502.84a8.22 8.22 0 00-8.22-8.22H205.41a8.22 8.22 0 00-8.22 8.22v49.47h31.38v-49.47zM316.76 494.51V438.4c0-4.08-2.97-7.45-6.86-8.1-.44-.07-.89-.12-1.35-.12h-14.94c-.46 0-.91.05-1.35.12-3.89.65-6.86 4.02-6.86 8.1V552.32h31.38v-57.81zM360.09 494.51v-91.32c0-1.92-.66-3.68-1.76-5.08-.38-.48-.8-.92-1.27-1.3a8.18 8.18 0 00-5.18-1.84h-14.94c-2.21 0-4.2.87-5.68 2.29a8.926 8.926 0 00-1.1 1.27c-.29.42-.54.87-.75 1.34-.45 1.01-.7 2.13-.7 3.31V552.3h31.38V494.51zM448.27 494.51V340.99c0-3.05-1.67-5.71-4.13-7.13a8.04 8.04 0 00-2.15-.85c-.4-.1-.81-.17-1.24-.2-.23-.02-.46-.04-.7-.04H425.1c-.67 0-1.32.09-1.94.24-.76.18-1.48.47-2.15.85a8.2 8.2 0 00-4.13 7.13V552.31h31.38v-57.8zM404.18 494.51V370.88c0-1.83-.61-3.52-1.62-4.88a8.176 8.176 0 00-6.6-3.33h-14.95a8.176 8.176 0 00-6.6 3.33 8.191 8.191 0 00-1.62 4.88V552.31h31.38v-57.8zM535.69 287.81a8.22 8.22 0 00-8.22-8.22h-14.94a8.22 8.22 0 00-8.22 8.22V552.3h23.91a7.47 7.47 0 007.47-7.47V287.81zM492.35 494.51V308.22a8.187 8.187 0 00-4.55-7.34 8.233 8.233 0 00-3.67-.87h-14.94c-.27 0-.53.01-.8.04-.25.02-.5.06-.75.11-.75.14-1.46.39-2.13.72a8.187 8.187 0 00-4.55 7.34V552.53h31.38v-58.02zM132.94 542.9H118a8.22 8.22 0 00-8.22 8.22v1.43h31.38v-1.43a8.222 8.222 0 00-5.28-7.67c-.92-.35-1.9-.55-2.94-.55zM177.03 525.71h-14.95c-.35 0-.69.03-1.03.07-.98.12-1.91.42-2.75.85-2.63 1.37-4.44 4.12-4.44 7.29v18.62h31.38v-18.62a8.208 8.208 0 00-7.19-8.14c-.33-.04-.67-.07-1.02-.07z"
          className="st10"
        ></path>
      </g>
    )
  })
  
  
  const CheckoutCard =  React.forwardRef((props, ref:any) => {
    return (
       
      <g ref={ref} {...props}>
        <linearGradient
          id="SVGID_00000060008633660729515690000017154591254051089048_"
          x1="-0.102"
          x2="0.621"
          y1="798.584"
          y2="797.939"
          gradientTransform="matrix(230.633 0 0 -87.753 277.894 70292.375)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0" stopColor="#1A4D88"></stop>
          <stop offset="1" stopColor="#161749"></stop>
        </linearGradient>
        <path
          fill="url(#SVGID_00000060008633660729515690000017154591254051089048_)"
          d="M373.84 252.8c-.54 0-.98.18-1.33.55-.35.36-.52.82-.52 1.38 0 .57.17 1.03.52 1.4.35.36.79.55 1.33.55.56 0 1.01-.18 1.35-.55.34-.36.52-.83.52-1.4s-.17-1.03-.52-1.39c-.35-.37-.8-.54-1.35-.54z"
        ></path>
        <linearGradient
          id="SVGID_00000171697382666572005960000002957718955870313379_"
          x1="-0.139"
          x2="0.584"
          y1="798.542"
          y2="797.898"
          gradientTransform="matrix(230.633 0 0 -87.753 277.894 70292.375)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0" stopColor="#1A4D88"></stop>
          <stop offset="1" stopColor="#161749"></stop>
        </linearGradient>
        <path
          fill="url(#SVGID_00000171697382666572005960000002957718955870313379_)"
          d="M350.78 252.59c-.47 0-.86.12-1.17.37-.31.24-.53.58-.65 1.01h3.5c-.21-.93-.76-1.38-1.68-1.38z"
        ></path>
        <linearGradient
          id="SVGID_00000127003589882571732620000000116211307074945724_"
          x1="-0.218"
          x2="0.504"
          y1="798.453"
          y2="797.808"
          gradientTransform="matrix(230.633 0 0 -87.753 277.894 70292.375)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0" stopColor="#1A4D88"></stop>
          <stop offset="1" stopColor="#161749"></stop>
        </linearGradient>
        <path
          fill="url(#SVGID_00000127003589882571732620000000116211307074945724_)"
          d="M282.59 243.52L282.59 243.52 280.63 244.65z"
        ></path>
        <linearGradient
          id="SVGID_00000110466053016478570280000011458681410792624831_"
          x1="-0.145"
          x2="0.578"
          y1="798.536"
          y2="797.891"
          gradientTransform="matrix(230.633 0 0 -87.753 277.894 70292.375)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0" stopColor="#1A4D88"></stop>
          <stop offset="1" stopColor="#161749"></stop>
        </linearGradient>
        <path
          fill="url(#SVGID_00000110466053016478570280000011458681410792624831_)"
          d="M289.65 228.47c-.03-.11-.07-.21-.12-.31-.34-.63-1.12-.87-1.75-.53s-.87 1.12-.53 1.75l3.97 10.3c.23.72 1 1.12 1.72.9.68-.32.98-1.12.68-1.81l-3.97-10.3z"
        ></path>
        <linearGradient
          id="SVGID_00000134942292029441516090000008920606021071806348_"
          x1="-0.147"
          x2="0.576"
          y1="798.534"
          y2="797.889"
          gradientTransform="matrix(230.633 0 0 -87.753 277.894 70292.375)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0" stopColor="#1A4D88"></stop>
          <stop offset="1" stopColor="#161749"></stop>
        </linearGradient>
        <path
          fill="url(#SVGID_00000134942292029441516090000008920606021071806348_)"
          d="M304.54 235.25c-.33-.63-1.12-.87-1.75-.54s-.87 1.11-.54 1.75l2.79 7.24 2.25-1.3-2.64-6.86c-.03-.1-.06-.2-.11-.29z"
        ></path>
        <linearGradient
          id="SVGID_00000149366786933287298470000018291161238966014351_"
          x1="-0.309"
          x2="0.414"
          y1="798.352"
          y2="797.707"
          gradientTransform="matrix(230.633 0 0 -87.753 277.894 70292.375)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0" stopColor="#1A4D88"></stop>
          <stop offset="1" stopColor="#161749"></stop>
        </linearGradient>
        <path
          fill="url(#SVGID_00000149366786933287298470000018291161238966014351_)"
          d="M270.98 251.46l.24 5.57c.21 1.08.9 2.01 1.87 2.53l.16.09c.35-.05.72.03 1.01.25.38.25.7.56.97.9l11.62 6.7c.35-.05.7.03.99.25.37.24.69.54.96.88l2.68 1.54c1 .42 2.14.35 3.09-.18l12.26-7.07c.29-.19.46-.42.45-.62-.01-.2-.2-.39-.51-.55-.09.11-.19.22-.31.3l-1.32.75-.01-.01c-.36.23-.87.21-1.43-.12a4.374 4.374 0 01-1.81-2.57l-5.51 3.18-2.47 1.42-22.93-13.24z"
        ></path>
        <linearGradient
          id="SVGID_00000176760994681581269670000013988110600596350848_"
          x1="-0.15"
          x2="0.572"
          y1="798.53"
          y2="797.885"
          gradientTransform="matrix(230.633 0 0 -87.753 277.894 70292.375)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0" stopColor="#1A4D88"></stop>
          <stop offset="1" stopColor="#161749"></stop>
        </linearGradient>
        <path
          fill="url(#SVGID_00000176760994681581269670000013988110600596350848_)"
          d="M300.44 244.11c.69-.31 1-1.12.69-1.81l-3.97-10.3c-.03-.11-.07-.21-.12-.31-.34-.63-1.13-.86-1.76-.53-.63.34-.86 1.13-.53 1.76l3.96 10.3c.24.71 1.01 1.11 1.73.89z"
        ></path>
        <linearGradient
          id="SVGID_00000102528815474309813160000000223216133786123420_"
          x1="-0.136"
          x2="0.587"
          y1="798.545"
          y2="797.901"
          gradientTransform="matrix(230.633 0 0 -87.753 277.894 70292.375)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0" stopColor="#1A4D88"></stop>
          <stop offset="1" stopColor="#161749"></stop>
        </linearGradient>
        <path
          fill="url(#SVGID_00000102528815474309813160000000223216133786123420_)"
          d="M408.13 212.48H247.76c-3.3 0-5.98 2.68-5.98 5.98v53.62c0 3.3 2.68 5.98 5.98 5.98h160.38c3.3 0 5.98-2.68 5.98-5.98v-53.62a5.986 5.986 0 00-5.99-5.98zm-54.75 20.11h1.96v6.9l2.63-3.32h2.26l-2.84 3.44 2.99 3.78h-2.39l-2.64-3.51v3.51h-1.96v-10.8zm-3.51.51c.21-.22.47-.33.79-.33.32 0 .58.11.79.33.21.22.31.48.31.79 0 .32-.1.59-.31.8s-.47.32-.79.32c-.32 0-.58-.11-.79-.32s-.31-.48-.31-.8c-.01-.31.1-.57.31-.79zm1.78 3.08v7.22h-1.97v-7.22h1.97zm-84.22-8.09c-.36-1.37.16-2.81 1.31-3.64l12.24-6.91a1.729 1.729 0 012.72 1.05l.85 2.75-.84.49-.92-2.78c-.12-.5-.63-.8-1.12-.67-.12.03-.24.09-.34.16l-11.91 6.73c-.73.53-1.07 1.46-.86 2.34l.72 2.64-1 .58-.85-2.74zm42.94 27.13l-4.59 2.65c.77.75 1.24 1.76 1.3 2.85l.18.1c.83.28 1.27 1.18.99 2.01-.14.41-.44.74-.83.93l-12.26 7.07c-.62.37-1.32.58-2.05.61-.71.05-1.43-.07-2.08-.37l-1.36-.78c.07.28.12.57.14.86.05.51-.18 1-.61 1.28l-1.32.75-.01-.01c-.36.23-.87.21-1.43-.11a4.327 4.327 0 01-1.94-3.41c.01-.64.24-1.08.61-1.28l.61-.34-9.65-5.56c.07.28.12.57.13.86.05.51-.18 1-.61 1.28l-1.32.75-.01-.01c-.36.22-.87.2-1.42-.12a4.387 4.387 0 01-1.94-3.42c0-.63.24-1.07.61-1.27l.62-.35a4.667 4.667 0 01-1.94-3.09l-.27-6.24-.01-.01-1.63-20 16.26-9.5 1.8 19.98-1.8-19.98 29.61 17.09-3.78 16.78zm25.78 2.86c-.65.27-1.4.41-2.26.41-.78 0-1.49-.14-2.15-.41-.66-.27-1.23-.66-1.71-1.15s-.86-1.07-1.13-1.72c-.27-.65-.4-1.36-.4-2.13 0-.76.13-1.46.4-2.11.27-.65.64-1.23 1.13-1.72s1.05-.88 1.71-1.16a5.46 5.46 0 012.15-.42c.84 0 1.57.14 2.21.42.64.28 1.2.65 1.69 1.12l-1.38 1.37c-.3-.32-.66-.57-1.08-.75-.42-.18-.9-.27-1.45-.27-.65 0-1.22.15-1.72.44s-.89.71-1.17 1.23c-.28.53-.43 1.14-.43 1.84 0 .71.14 1.32.43 1.85.28.53.67.94 1.17 1.23.5.29 1.07.44 1.72.44.59 0 1.09-.09 1.51-.27.42-.18.78-.43 1.08-.76l1.38 1.37c-.49.5-1.05.87-1.7 1.15zm-.78-14.68l-4.32-5.19v5.19h-2.03v-10.51h2.03v4.75l4.2-4.75h2.54l-4.53 5.01 4.69 5.5h-2.58zm10.51 14.94h-1.96v-4.14c0-.43-.14-.78-.41-1.05-.27-.27-.62-.4-1.04-.4-.42 0-.76.13-1.04.4-.27.27-.41.62-.41 1.05v4.14h-1.96v-10.8h1.96v4.26c.25-.26.55-.46.9-.6s.73-.22 1.15-.22c.55 0 1.03.12 1.46.36.42.24.75.57.99.99s.36.9.36 1.45v4.56zm-1.15-14.94l-1.54-4.23-1.55 4.23h-1.41l-2.7-7.22h1.97l1.46 4.39 1.51-4.39h1.42l1.51 4.39 1.46-4.39h1.97l-2.69 7.22h-1.41zm9.5 12.01l-5.28.02c.12.45.35.8.69 1.05s.76.37 1.26.37c.36 0 .69-.06.99-.19s.57-.31.79-.56l1.15 1.15c-.36.42-.79.73-1.29.93s-1.04.31-1.63.31c-.76 0-1.43-.16-2.03-.49-.59-.32-1.06-.77-1.4-1.34s-.51-1.22-.51-1.94c0-.71.17-1.34.5-1.91.33-.57.79-1.02 1.37-1.35s1.22-.5 1.93-.5c.69 0 1.3.16 1.83.47.53.31.95.74 1.26 1.29s.46 1.16.46 1.85c.02.24-.02.52-.09.84zm4.72 3.08c-.74 0-1.4-.16-1.99-.49a3.678 3.678 0 01-1.9-3.26c0-.72.17-1.36.52-1.93s.81-1.02 1.39-1.35 1.24-.5 1.98-.5c1.15 0 2.08.4 2.81 1.21l-1.26 1.27c-.39-.43-.91-.64-1.55-.64-.55 0-1 .18-1.35.54-.35.36-.53.82-.53 1.39 0 .58.18 1.05.53 1.4.35.36.8.54 1.35.54.66 0 1.18-.22 1.57-.67l1.27 1.27c-.74.81-1.69 1.22-2.84 1.22zm8.55-.15l-2.64-3.51v3.51h-1.96v-10.8h1.96v6.9l2.63-3.32h2.26l-2.84 3.44 2.99 3.78h-2.4zm9.7-1.7c-.34.57-.8 1.02-1.38 1.35-.58.33-1.24.49-1.97.49s-1.38-.17-1.96-.5-1.05-.78-1.39-1.35-.52-1.21-.52-1.93c0-.7.17-1.33.51-1.9s.8-1.02 1.38-1.35c.58-.33 1.24-.5 1.97-.5s1.38.17 1.97.5 1.05.78 1.39 1.34c.34.56.51 1.2.51 1.91 0 .73-.17 1.37-.51 1.94zm8.1-1.33c0 .64-.14 1.2-.41 1.67-.27.48-.66.85-1.15 1.11s-1.06.4-1.7.4-1.2-.13-1.7-.4-.88-.64-1.16-1.12c-.28-.48-.42-1.03-.42-1.66v-4.18h1.97v4.14c0 .45.11.8.34 1.05.23.25.55.37.96.37s.73-.12.96-.37c.23-.24.34-.6.34-1.05v-4.14h1.96v4.18zm6.26-2.47h-1.69v5.5h-1.96v-5.5h-1.69v-1.72h1.69v-3h1.96v3h1.69v1.72z"
        ></path>
        <path
          d="M337.79 232.89L335.25 232.89 331.05 237.64 331.05 232.89 329.02 232.89 329.02 243.4 331.05 243.4 331.05 238.21 335.37 243.4 337.96 243.4 333.27 237.9z"
          className="st1"
        ></path>
        <path
          d="M346.86 236.18L345.4 240.57 343.89 236.18 342.47 236.18 340.96 240.57 339.5 236.18 337.53 236.18 340.23 243.4 341.63 243.4 343.19 239.17 344.73 243.4 346.15 243.4 348.84 236.18z"
          className="st1"
        ></path>
        <path
          d="M349.67 236.18H351.64000000000004V243.4H349.67z"
          className="st1"
        ></path>
        <path
          d="M350.66 235.01c.32 0 .58-.11.79-.32s.31-.48.31-.8c0-.31-.1-.57-.31-.79-.21-.22-.47-.33-.79-.33-.32 0-.58.11-.79.33-.21.22-.31.48-.31.79 0 .32.11.59.31.8s.47.32.79.32z"
          className="st1"
        ></path>
        <path
          d="M355.34 239.88L357.98 243.4 360.37 243.4 357.39 239.61 360.23 236.18 357.97 236.18 355.34 239.49 355.34 232.59 353.38 232.59 353.38 243.4 355.34 243.4z"
          className="st1"
        ></path>
        <path
          d="M335.4 256.34c-.42.18-.92.27-1.51.27-.65 0-1.22-.15-1.72-.44-.5-.29-.89-.71-1.17-1.23-.28-.53-.43-1.15-.43-1.85 0-.7.14-1.31.43-1.84.28-.53.67-.94 1.17-1.23s1.07-.44 1.72-.44c.55 0 1.03.09 1.45.27.42.18.78.43 1.08.75l1.38-1.37c-.49-.47-1.05-.84-1.69-1.12-.64-.28-1.38-.42-2.21-.42-.78 0-1.49.14-2.15.42-.66.28-1.23.67-1.71 1.16s-.86 1.07-1.13 1.72c-.27.65-.4 1.36-.4 2.11 0 .77.13 1.48.4 2.13.27.65.64 1.23 1.13 1.72s1.05.88 1.71 1.15c.66.27 1.38.41 2.15.41.86 0 1.61-.14 2.26-.41.65-.27 1.21-.65 1.7-1.13l-1.38-1.37c-.3.3-.66.56-1.08.74zM344.53 251.33c-.42-.24-.91-.36-1.46-.36a2.837 2.837 0 00-2.05.82v-4.26h-1.96v10.8h1.96v-4.14c0-.43.14-.78.41-1.05.27-.27.62-.4 1.04-.4.42 0 .76.13 1.04.4.27.27.41.62.41 1.05v4.14h1.96v-4.57c0-.55-.12-1.03-.36-1.45s-.57-.74-.99-.98zM352.61 251.43c-.53-.31-1.14-.47-1.83-.47-.71 0-1.35.17-1.93.5s-1.03.78-1.37 1.35c-.33.57-.5 1.21-.5 1.91 0 .73.17 1.37.51 1.94s.8 1.01 1.4 1.34c.59.32 1.27.49 2.03.49.59 0 1.13-.1 1.63-.31s.93-.52 1.29-.93l-1.15-1.15c-.22.25-.48.44-.79.56s-.63.19-.99.19c-.5 0-.92-.12-1.26-.37s-.57-.6-.69-1.05l5.28-.02c.07-.32.1-.6.1-.85 0-.69-.15-1.3-.46-1.85s-.74-.97-1.27-1.28zm-3.65 2.53c.12-.43.34-.76.65-1.01.31-.24.7-.37 1.17-.37.92 0 1.47.46 1.67 1.37h-3.49zM358.95 256.67c-.55 0-1-.18-1.35-.54-.35-.36-.53-.83-.53-1.4s.18-1.03.53-1.39c.35-.36.8-.54 1.35-.54.65 0 1.17.21 1.55.64l1.26-1.27c-.73-.81-1.66-1.21-2.81-1.21-.74 0-1.4.17-1.98.5s-1.05.78-1.39 1.35-.52 1.21-.52 1.93a3.678 3.678 0 001.9 3.26c.59.33 1.25.49 1.99.49 1.15 0 2.09-.41 2.84-1.23l-1.27-1.27c-.38.45-.91.68-1.57.68z"
          className="st1"
        ></path>
        <path
          d="M369.74 251.12L367.49 251.12 364.86 254.44 364.86 247.53 362.9 247.53 362.9 258.34 364.86 258.34 364.86 254.83 367.5 258.34 369.89 258.34 366.9 254.56z"
          className="st1"
        ></path>
        <path
          d="M375.81 251.46c-.59-.33-1.25-.5-1.97-.5-.73 0-1.38.17-1.97.5-.58.33-1.04.78-1.38 1.35s-.51 1.2-.51 1.9c0 .72.17 1.36.52 1.93s.81 1.02 1.39 1.35 1.24.5 1.96.5 1.38-.16 1.97-.49c.58-.33 1.04-.78 1.38-1.35.34-.57.51-1.22.51-1.94 0-.71-.17-1.34-.51-1.91-.34-.56-.8-1.01-1.39-1.34zm-.62 4.66c-.34.36-.79.55-1.35.55-.54 0-.98-.18-1.33-.55-.35-.36-.52-.83-.52-1.4 0-.56.17-1.02.52-1.38.35-.36.79-.55 1.33-.55.55 0 1 .18 1.34.54.35.36.52.82.52 1.39s-.17 1.04-.51 1.4zM383.34 255.26c0 .46-.11.81-.34 1.05-.23.24-.55.37-.96.37s-.73-.12-.96-.37c-.23-.25-.34-.6-.34-1.05v-4.14h-1.97v4.18c0 .63.14 1.18.42 1.66.28.48.67.85 1.16 1.12s1.06.4 1.7.4 1.2-.13 1.7-.4.88-.64 1.15-1.11c.27-.48.41-1.04.41-1.67v-4.18h-1.96v4.14z"
          className="st1"
        ></path>
        <path
          d="M389.87 248.12L387.92 248.12 387.92 251.12 386.23 251.12 386.23 252.84 387.92 252.84 387.92 258.34 389.87 258.34 389.87 252.84 391.56 252.84 391.56 251.12 389.87 251.12z"
          className="st1"
        ></path>
        <path
          d="M305.12 259.59l1.95 1.13a4.35 4.35 0 00-1.3-2.85l-1.37.79c.28.28.53.59.72.93zM305.7 261.57c-.01.59-.21 1-.54 1.21l.01.01 1.32-.75c.12-.08.22-.19.31-.3l-1.14-.66c.02.15.05.31.05.47-.01 0-.01.01-.01.02z"
          className="st19"
        ></path>
        <path
          d="M303.73 262.67c.56.33 1.07.35 1.43.12.33-.21.54-.62.54-1.21l-1.3-.75c-.01.47-.3.68-.66.47-.4-.29-.63-.75-.65-1.23l-.55-.32-.62.36a4.34 4.34 0 001.81 2.56zM304.4 258.66l-.44.25 1.16.67c-.19-.33-.44-.64-.72-.92z"
          className="st1"
        ></path>
        <path
          d="M303.08 260.05c.02.49.25.95.65 1.23.37.21.65 0 .66-.47l-1.31-.76z"
          className="st20"
        ></path>
        <path
          d="M305.7 261.57v-.03c0-.16-.03-.31-.05-.47.02.15.04.31.05.47v.03z"
          className="st19"
        ></path>
        <path
          d="M305.7 261.57v-.03c0-.16-.03-.31-.05-.47.02.15.04.31.05.47v.03z"
          className="st21"
        ></path>
        <path
          d="M303.08 260.01c0-.16.04-.28.09-.37l-.23-.14-.4.23.55.32c-.01-.01-.01-.02-.01-.04z"
          className="st1"
        ></path>
        <path
          d="M303.08 260.01c0-.16.04-.28.09-.37l-.23-.14-.4.23.55.32c-.01-.01-.01-.02-.01-.04z"
          className="st21"
        ></path>
        <path
          d="M304.4 260.82l1.3.75v-.03c-.01-.16-.03-.31-.05-.47l-1.33-.77c.05.16.09.32.09.48-.01.02-.01.03-.01.04z"
          className="st1"
        ></path>
        <path
          d="M304.4 260.82l1.3.75v-.03c-.01-.16-.03-.31-.05-.47l-1.33-.77c.05.16.09.32.09.48-.01.02-.01.03-.01.04z"
          className="st21"
        ></path>
        <path
          d="M303.08 260.05l1.32.76v-.03c0-.17-.04-.33-.09-.48l-1.14-.66c-.05.1-.09.21-.09.37v.04z"
          className="st20"
        ></path>
        <path
          d="M303.08 260.05l1.32.76v-.03c0-.17-.04-.33-.09-.48l-1.14-.66c-.05.1-.09.21-.09.37v.04z"
          className="st21"
        ></path>
        <path
          d="M273.26 259.65l-.16-.09a3.7 3.7 0 01-1.87-2.53l-.24-5.57-1.06-.61.27 6.24c.2 1.26.91 2.37 1.94 3.09l.69-.39c.14-.08.28-.12.43-.14zM286.87 267.49l-11.62-6.7c.39.49.68 1.05.83 1.66l9.65 5.56.7-.39c.13-.07.28-.11.44-.13zM303.96 258.92l-1.02.59.23.14 1.14.66 1.33.77 1.14.66c.31.16.49.35.51.55.01.2-.16.43-.45.62l-12.26 7.07c-.95.53-2.09.6-3.09.18l-2.68-1.54c.4.49.69 1.06.85 1.67l1.36.78c.65.3 1.36.43 2.08.37a4.37 4.37 0 002.05-.61l12.26-7.07a1.589 1.589 0 00-.16-2.94l-.18-.1-1.95-1.13-1.16-.67z"
          className="st22"
        ></path>
        <path
          d="M287.86 267.73c-.29-.22-.65-.3-.99-.25-.15.02-.3.06-.45.14l-.7.39-.61.34c.35-.19.83-.15 1.36.16 1.16.76 1.88 2.03 1.94 3.42 0 .6-.21 1.02-.54 1.24l.01.01 1.32-.75c.42-.28.65-.78.61-1.28-.01-.3-.06-.58-.14-.86-.16-.62-.45-1.19-.85-1.67-.28-.34-.59-.64-.96-.89z"
          className="st19"
        ></path>
        <path
          d="M288.41 271.93a4.36 4.36 0 00-1.94-3.42c-.53-.31-1.01-.35-1.36-.16-.37.2-.61.64-.61 1.28.07 1.38.79 2.65 1.94 3.41.56.33 1.07.34 1.43.11.34-.19.54-.61.54-1.22zm-1.96-.26c-.41-.29-.65-.77-.66-1.27 0-.49.29-.72.67-.5.41.3.65.77.66 1.28 0 .48-.29.71-.67.49z"
          className="st1"
        ></path>
        <path
          d="M286.46 269.9c-.38-.22-.67.01-.67.5.01.5.25.98.66 1.27.37.22.67-.01.67-.5 0-.5-.25-.97-.66-1.27z"
          className="st20"
        ></path>
        <path
          d="M274.27 259.89c-.29-.22-.66-.3-1.01-.25-.15.02-.29.06-.43.13l-.69.39-.62.35c.36-.19.84-.15 1.37.16 1.15.76 1.87 2.03 1.94 3.41 0 .61-.21 1.03-.55 1.24l.01.01 1.32-.75c.42-.28.66-.77.61-1.28-.01-.29-.06-.58-.13-.86a4.26 4.26 0 00-.83-1.66 5.25 5.25 0 00-.99-.89z"
          className="st19"
        ></path>
        <path
          d="M274.82 264.08a4.369 4.369 0 00-1.94-3.41c-.53-.31-1.01-.35-1.37-.16-.37.2-.6.63-.61 1.27.06 1.38.78 2.65 1.94 3.42.56.32 1.06.35 1.42.12.35-.2.56-.63.56-1.24zm-1.96-.25c-.41-.3-.65-.77-.65-1.28 0-.49.29-.71.67-.5.41.3.65.77.66 1.28-.01.49-.3.71-.68.5z"
          className="st1"
        ></path>
        <path
          d="M272.87 262.06c-.38-.22-.67.01-.67.5 0 .51.25.98.65 1.28.38.21.67-.01.67-.5.01-.51-.24-.99-.65-1.28z"
          className="st20"
        ></path>
        <path
          d="M268.56 227.59c-.21-.88.13-1.8.86-2.34l11.91-6.73c.1-.08.22-.13.34-.16.5-.12 1 .18 1.12.67l.92 2.78.84-.49-.85-2.75a1.73 1.73 0 00-.3-.68c-.57-.77-1.65-.93-2.42-.37l-12.24 6.91a3.411 3.411 0 00-1.31 3.64l.85 2.73 1-.58-.72-2.63z"
          className="st22"
        ></path>
        <path
          d="M296.4 263.28L293.93 264.7 293.93 264.7z"
          className="st23"
        ></path>
        <path
          d="M296.4 263.28L293.93 264.7 293.93 264.7z"
          className="st24"
        ></path>
        <path
          d="M280.34 244.82l3.21 8.34c.23.72 1 1.11 1.72.89.69-.31 1-1.12.69-1.82l-3.36-8.72-1.96 1.13-.3.18z"
          className="st23"
        ></path>
        <path
          d="M280.34 244.82l3.21 8.34c.23.72 1 1.11 1.72.89.69-.31 1-1.12.69-1.82l-3.36-8.72-1.96 1.13-.3.18z"
          className="st24"
        ></path>
        <path
          d="M276.05 249.63c.23.72 1 1.12 1.72.9.69-.32.99-1.13.68-1.82l-.88-2.28-2.25 1.3.73 1.9z"
          className="st23"
        ></path>
        <path
          d="M276.05 249.63c.23.72 1 1.12 1.72.9.69-.32.99-1.13.68-1.82l-.88-2.28-2.25 1.3.73 1.9z"
          className="st24"
        ></path>
        <path
          d="M297.73 247.92L297.73 247.92 297.41 247.73z"
          className="st23"
        ></path>
        <path
          d="M297.73 247.92L297.73 247.92 297.41 247.73z"
          className="st24"
        ></path>
        <path
          d="M289.36 245.16a1.29 1.29 0 00-1.75-.53 1.29 1.29 0 00-.53 1.75l3.97 10.3c.23.72 1 1.12 1.72.89.69-.32.99-1.13.68-1.82l-3.97-10.3a2.24 2.24 0 00-.12-.29z"
          className="st23"
        ></path>
        <path
          d="M289.36 245.16a1.29 1.29 0 00-1.75-.53 1.29 1.29 0 00-.53 1.75l3.97 10.3c.23.72 1 1.12 1.72.89.69-.32.99-1.13.68-1.82l-3.97-10.3a2.24 2.24 0 00-.12-.29z"
          className="st24"
        ></path>
        <path
          d="M275.31 247.72l2.25-1.3-3.09-8.01c-.03-.1-.06-.2-.11-.29a1.29 1.29 0 00-1.75-.53 1.29 1.29 0 00-.53 1.75l3.23 8.38z"
          className="st25"
        ></path>
        <path
          d="M275.31 247.72l2.25-1.3-3.09-8.01c-.03-.1-.06-.2-.11-.29a1.29 1.29 0 00-1.75-.53 1.29 1.29 0 00-.53 1.75l3.23 8.38z"
          className="st26"
        ></path>
        <path
          d="M280.34 244.82l.3-.17 1.96-1.13-.61-1.58c-.03-.1-.06-.2-.12-.3a1.29 1.29 0 00-1.75-.53 1.29 1.29 0 00-.53 1.75l.75 1.96z"
          className="st25"
        ></path>
        <path
          d="M280.34 244.82l.3-.17 1.96-1.13-.61-1.58c-.03-.1-.06-.2-.12-.3a1.29 1.29 0 00-1.75-.53 1.29 1.29 0 00-.53 1.75l.75 1.96z"
          className="st26"
        ></path>
        <path
          d="M268.28 230.84L269.92 250.84 268.28 230.84z"
          className="st25"
        ></path>
        <path
          d="M268.28 230.84L269.92 250.84 268.28 230.84z"
          className="st26"
        ></path>
        <path
          d="M286.35 241.32L284.55 221.34 268.28 230.84z"
          className="st25"
        ></path>
        <path
          d="M286.35 241.32L284.55 221.34 268.28 230.84z"
          className="st26"
        ></path>
        <path
          d="M297.41 247.73l.32.19 7.31-4.22-2.79-7.24a1.294 1.294 0 112.4-.93l2.64 6.86 6.86-3.96-29.61-17.09 1.8 19.98 11.07 6.41zm-4.46-7.15c-.72.22-1.49-.18-1.72-.9l-3.97-10.3c-.34-.63-.1-1.42.53-1.75s1.42-.1 1.75.53c.05.1.09.2.12.31l3.97 10.3c.3.69 0 1.5-.68 1.81zm2.34-9.42a1.302 1.302 0 011.88.84l3.97 10.3c.31.69 0 1.5-.69 1.82a1.37 1.37 0 01-1.72-.89l-3.96-10.3c-.35-.65-.11-1.43.52-1.77z"
          className="st27"
        ></path>
        <path
          d="M293.93 264.7l3.79-16.78-.32-.19-11.06-6.42-18.06-10.48 1.63 20 .01.01 1.06.61 22.95 13.25zm-.49-8.94c.31.69.01 1.5-.68 1.82a1.37 1.37 0 01-1.72-.89l-3.97-10.3c-.34-.63-.1-1.42.53-1.75.63-.34 1.42-.1 1.75.53.05.09.09.19.12.3l3.97 10.29zm-13.33-14.65c.63-.34 1.42-.1 1.75.53.05.09.09.19.12.3l.61 1.58 3.36 8.72c.31.69 0 1.5-.69 1.82a1.37 1.37 0 01-1.72-.89l-3.21-8.34-.75-1.96c-.33-.64-.1-1.42.53-1.76zm-7.5-3.53a1.29 1.29 0 011.86.82l3.09 8.01.88 2.28c.31.69.01 1.5-.68 1.82-.72.22-1.49-.18-1.72-.9l-.74-1.91-3.24-8.39c-.32-.61-.08-1.39.55-1.73z"
          className="st23"
        ></path>
        <path
          d="M307.29 242.4L305.04 243.7 297.73 247.92 297.73 247.92 297.72 247.92 293.93 264.7 293.93 264.7 296.4 263.28 301.91 260.1 302.54 259.74 302.94 259.51 303.96 258.92 304.4 258.66 305.77 257.87 310.37 255.22 314.16 238.43 314.16 238.43z"
          className="st28"
        ></path>
      </g>
    )
  })
  
  const SmartCOD = React.forwardRef((props, ref:any)  => {
    return (
      <g {...props} ref={ref}>
        <linearGradient
          id="SVGID_00000019643686011898192040000018256871185525251733_"
          x1="1.586"
          x2="2.365"
          y1="795.076"
          y2="794.381"
          gradientTransform="matrix(230.671 0 0 -88.753 0 71084.375)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0" stopColor="#1A4D88"></stop>
          <stop offset="1" stopColor="#161749"></stop>
        </linearGradient>
        <path
          fill="url(#SVGID_00000019643686011898192040000018256871185525251733_)"
          d="M456.2 552.11c.59 0 1.07-.2 1.44-.59.37-.39.55-.9.55-1.52 0-.61-.18-1.11-.55-1.51-.37-.39-.84-.59-1.44-.59-.58 0-1.05.2-1.42.59s-.55.89-.55 1.51.18 1.13.55 1.52.84.59 1.42.59z"
        ></path>
        <linearGradient
          id="SVGID_00000119079492926162260060000015037774094107351939_"
          x1="1.485"
          x2="1.713"
          y1="794.963"
          y2="794.759"
          gradientTransform="matrix(230.671 0 0 -88.753 0 71084.375)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0" stopColor="#1A4D88"></stop>
          <stop offset="1" stopColor="#161749"></stop>
        </linearGradient>
        <path
          fill="url(#SVGID_00000119079492926162260060000015037774094107351939_)"
          d="M404.28 550.24L404.28 550.24 404.28 550.24 404.28 550.24z"
        ></path>
        <linearGradient
          id="SVGID_00000120533440874440672800000016182113801924536233_"
          x1="1.512"
          x2="2.291"
          y1="794.993"
          y2="794.297"
          gradientTransform="matrix(230.671 0 0 -88.753 0 71084.375)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0" stopColor="#1A4D88"></stop>
          <stop offset="1" stopColor="#161749"></stop>
        </linearGradient>
        <path
          fill="url(#SVGID_00000120533440874440672800000016182113801924536233_)"
          d="M460.74 563.82c-.5 0-.93.13-1.27.4s-.57.63-.7 1.09h3.77c-.21-1-.81-1.49-1.8-1.49z"
        ></path>
        <linearGradient
          id="SVGID_00000136399600562989875880000014016290256437202097_"
          x1="1.514"
          x2="2.293"
          y1="794.995"
          y2="794.3"
          gradientTransform="matrix(230.671 0 0 -88.753 0 71084.375)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0" stopColor="#1A4D88"></stop>
          <stop offset="1" stopColor="#161749"></stop>
        </linearGradient>
        <path
          fill="url(#SVGID_00000136399600562989875880000014016290256437202097_)"
          d="M523.55 520.55H350.48c-3.56 0-6.45 2.89-6.45 6.45v58.65c0 3.56 2.89 6.45 6.45 6.45h173.07c3.56 0 6.45-2.89 6.45-6.45V527c0-3.57-2.89-6.45-6.45-6.45zm-70.99 27.4c.33-.62.77-1.1 1.34-1.46s1.2-.53 1.89-.53c.46 0 .89.08 1.28.24s.72.38.99.66v-.74h2.1v7.79h-2.1v-.74c-.27.28-.6.5-.98.66-.39.16-.81.24-1.27.24-.71 0-1.35-.18-1.91-.53s-1.01-.84-1.34-1.45c-.33-.61-.49-1.3-.49-2.06s.16-1.47.49-2.08zm-48.28 2.29l9.83-5.67v22.73l-7.77 4.48-5.74 7.38c-.31.4-.9.48-1.3.16a.928.928 0 01-.36-.73v-2.54l-9.41 5.42-.94-.54a.91.91 0 01-.96.43.935.935 0 01-.76-.85c-.01-.18-.02-.39-.02-.58l-21.91-12.65v-22.71l24.58 14.19 9.62-5.56h-.01l-9.62 5.55-24.58-14.19 9.85-5.69-.03.01 2.08-1.2 12.67-7.31 24.58 14.19-9.8 5.68zm31.68 19.05c-.74.6-1.76.89-3.05.89-.92 0-1.71-.15-2.35-.46-.64-.31-1.23-.78-1.76-1.41l1.45-1.45c.33.44.72.78 1.15 1.02.44.24.98.36 1.62.36.57 0 1.02-.11 1.36-.34.34-.23.51-.54.51-.94 0-.34-.1-.62-.29-.84s-.45-.4-.77-.54c-.32-.15-.67-.28-1.05-.41s-.76-.27-1.14-.44c-.38-.16-.73-.36-1.05-.6-.32-.24-.57-.55-.77-.94-.19-.38-.29-.86-.29-1.44 0-.68.17-1.26.5-1.74.33-.48.79-.86 1.37-1.12.58-.26 1.24-.4 1.97-.4.77 0 1.47.15 2.1.44.62.29 1.13.67 1.53 1.13l-1.45 1.45c-.33-.37-.67-.63-1.02-.81-.35-.17-.74-.26-1.18-.26-.52 0-.92.1-1.2.29-.29.19-.43.47-.43.84 0 .31.1.56.29.76.19.19.45.36.77.5s.67.27 1.05.39.76.27 1.14.44.73.39 1.05.65c.32.26.57.59.77.98s.29.89.29 1.48c0 1.1-.38 1.93-1.12 2.52zm0-16.12c-.74.6-1.76.89-3.05.89-.92 0-1.71-.15-2.35-.46-.64-.31-1.23-.78-1.76-1.41l1.45-1.45c.33.44.72.78 1.15 1.02.44.24.98.36 1.62.36.57 0 1.02-.11 1.36-.34.34-.23.51-.54.51-.94 0-.34-.1-.62-.29-.84s-.45-.4-.77-.54c-.32-.15-.67-.28-1.05-.41s-.76-.27-1.14-.44c-.38-.16-.73-.36-1.05-.6-.32-.24-.57-.55-.77-.94-.19-.38-.29-.86-.29-1.44 0-.68.17-1.26.5-1.74.33-.48.79-.86 1.37-1.12.58-.26 1.24-.4 1.97-.4.77 0 1.47.15 2.1.44.62.29 1.13.67 1.53 1.13l-1.45 1.45c-.33-.37-.67-.63-1.02-.81-.35-.17-.74-.26-1.18-.26-.52 0-.92.1-1.2.29-.29.19-.43.47-.43.84 0 .31.1.56.29.76.19.19.45.36.77.5s.67.27 1.05.39.76.27 1.14.44.73.39 1.05.65c.32.26.57.59.77.98s.29.89.29 1.48c0 1.09-.38 1.92-1.12 2.52zm9.45 13.58c0 .69-.15 1.29-.44 1.81-.3.52-.71.92-1.24 1.2-.53.28-1.14.43-1.83.43-.69 0-1.3-.14-1.83-.44-.53-.29-.95-.69-1.25-1.21s-.45-1.11-.45-1.79v-4.51h2.13v4.47c0 .48.12.86.37 1.13s.59.4 1.03.4c.44 0 .78-.13 1.03-.39s.37-.64.37-1.14v-4.47h2.11v4.51zm.36-17.44v4.6h-2.11v-4.6c0-.45-.14-.8-.43-1.06s-.64-.38-1.06-.38c-.42 0-.77.13-1.06.38s-.43.6-.43 1.06v4.6h-2.11v-7.79h2.11v.68c.56-.56 1.28-.84 2.18-.84.49 0 .95.1 1.36.31.41.2.75.49 1.01.87.3-.38.67-.67 1.1-.87.43-.2.92-.31 1.44-.31.57 0 1.09.12 1.55.36.46.24.83.59 1.1 1.04.27.45.41.99.41 1.61v4.93h-2.11v-4.6c0-.45-.14-.8-.43-1.06-.29-.25-.64-.38-1.06-.38-.42 0-.77.13-1.06.38s-.4.62-.4 1.07zm3.45 20.72h-2.13v-7.79h2.13v7.79zm-.21-9.4c-.23.23-.51.35-.85.35-.34 0-.63-.12-.85-.35-.23-.23-.34-.52-.34-.86 0-.33.11-.62.34-.85s.51-.35.85-.35c.34 0 .63.12.85.35.23.24.34.52.34.85-.01.35-.12.63-.34.86zm7.16 3.46h-1.82v5.93h-2.11v-5.93h-1.82v-1.85h1.82V559h2.11v3.24h1.82v1.85zm8.3 2.78l-5.69.02c.13.48.38.86.74 1.13s.82.4 1.35.4c.39 0 .74-.07 1.07-.2.33-.13.61-.34.85-.61l1.24 1.24c-.39.45-.85.79-1.39 1.01-.54.22-1.12.33-1.76.33-.82 0-1.55-.17-2.19-.52-.64-.35-1.14-.83-1.51-1.44-.37-.61-.55-1.31-.55-2.1 0-.76.18-1.45.54-2.06s.85-1.1 1.48-1.46 1.32-.54 2.08-.54c.74 0 1.4.17 1.98.51.57.34 1.03.8 1.36 1.39s.5 1.25.5 1.99c.01.26-.03.56-.1.91zm2.21-18.61c-.26-.26-.59-.39-1-.39-.46 0-.83.14-1.11.43-.28.29-.42.72-.42 1.3v4.3h-2.11v-7.79h2.11v.69c.24-.27.52-.48.85-.63.33-.15.72-.23 1.16-.23.75 0 1.37.26 1.84.79l-1.32 1.53zm7.21-.29h-1.82v5.93h-2.11v-5.93h-1.82v-1.85h1.82v-3.24h2.11v3.24h1.82v1.85zm12.25 5.65c-.7.3-1.51.44-2.43.44-.84 0-1.61-.15-2.32-.44-.71-.3-1.33-.71-1.85-1.24s-.93-1.15-1.22-1.85-.44-1.47-.44-2.3c0-.82.15-1.58.44-2.28s.7-1.32 1.22-1.85 1.14-.95 1.85-1.25c.71-.3 1.48-.45 2.32-.45.9 0 1.7.15 2.39.45.69.3 1.29.7 1.82 1.21l-1.48 1.48c-.32-.34-.71-.61-1.16-.81s-.97-.29-1.56-.29c-.7 0-1.32.16-1.85.48-.54.32-.96.76-1.27 1.33-.31.57-.46 1.23-.46 1.98 0 .76.15 1.43.46 2 .31.57.73 1.01 1.27 1.33.54.32 1.16.48 1.85.48.63 0 1.18-.1 1.63-.29.45-.19.84-.47 1.16-.82l1.48 1.48c-.54.51-1.15.92-1.85 1.21zm13.62-3.09a5.869 5.869 0 01-3.1 3.1c-.7.3-1.47.45-2.3.45-.83 0-1.6-.15-2.31-.45-.71-.3-1.33-.72-1.87-1.25a5.67 5.67 0 01-1.26-1.86c-.3-.71-.45-1.48-.45-2.31 0-.82.15-1.58.44-2.28.3-.7.71-1.32 1.24-1.85s1.15-.95 1.86-1.24c.71-.29 1.48-.44 2.31-.44.83 0 1.6.15 2.31.44.71.3 1.34.71 1.87 1.24s.95 1.15 1.25 1.86c.3.71.45 1.47.45 2.29.01.83-.14 1.59-.44 2.3zm12.06-.04a5.544 5.544 0 01-3.09 3c-.7.28-1.48.42-2.31.42h-4.45v-11.33h4.42c.84 0 1.61.14 2.33.42a5.53 5.53 0 013.11 2.99c.3.69.44 1.44.44 2.26-.01.79-.16 1.55-.45 2.24z"
        ></path>
        <linearGradient
          id="SVGID_00000026865084779201462950000008120583180201935037_"
          x1="1.691"
          x2="2.47"
          y1="795.194"
          y2="794.498"
          gradientTransform="matrix(230.671 0 0 -88.753 0 71084.375)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0" stopColor="#1A4D88"></stop>
          <stop offset="1" stopColor="#161749"></stop>
        </linearGradient>
        <path
          fill="url(#SVGID_00000026865084779201462950000008120583180201935037_)"
          d="M508.25 544.98c-.55-.31-1.18-.46-1.9-.46h-2.19v7.43h2.19c.73 0 1.37-.15 1.92-.46.55-.31.97-.74 1.28-1.3.31-.56.46-1.22.46-1.98 0-.74-.16-1.39-.47-1.94s-.75-.98-1.29-1.29z"
        ></path>
        <linearGradient
          id="SVGID_00000140701051078988716050000002202340063306291609_"
          x1="1.669"
          x2="2.449"
          y1="795.17"
          y2="794.474"
          gradientTransform="matrix(230.671 0 0 -88.753 0 71084.375)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0" stopColor="#1A4D88"></stop>
          <stop offset="1" stopColor="#161749"></stop>
        </linearGradient>
        <path
          fill="url(#SVGID_00000140701051078988716050000002202340063306291609_)"
          d="M496.22 544.91c-.54-.32-1.17-.48-1.89-.48-.71 0-1.34.16-1.88.48s-.97.77-1.27 1.34c-.31.57-.46 1.23-.46 1.97 0 .76.15 1.43.46 2.01.31.58.73 1.02 1.27 1.34.54.32 1.17.48 1.88.48.72 0 1.35-.16 1.89-.48.54-.32.97-.76 1.27-1.34.31-.57.46-1.24.46-2.01 0-.74-.15-1.4-.46-1.97a3.22 3.22 0 00-1.27-1.34z"
        ></path>
        <path
          d="M436.02 548.21c-.32-.26-.67-.47-1.05-.65s-.76-.32-1.14-.44c-.38-.12-.73-.25-1.05-.39a2.63 2.63 0 01-.77-.5c-.19-.19-.29-.45-.29-.76 0-.37.14-.65.43-.84.28-.19.68-.29 1.2-.29.44 0 .84.09 1.18.26.35.17.69.44 1.02.81l1.45-1.45c-.4-.46-.91-.84-1.53-1.13-.62-.29-1.32-.44-2.1-.44-.73 0-1.39.13-1.97.4-.58.26-1.04.64-1.37 1.12-.33.48-.5 1.06-.5 1.74 0 .58.1 1.06.29 1.44.19.38.45.69.77.94.32.24.67.44 1.05.6.38.16.76.31 1.14.44s.73.27 1.05.41c.32.14.58.33.77.54s.29.49.29.84c0 .4-.17.71-.51.94-.34.23-.79.34-1.36.34-.65 0-1.19-.12-1.62-.36-.44-.24-.82-.58-1.15-1.02l-1.45 1.45c.53.63 1.11 1.1 1.76 1.41.65.31 1.43.46 2.35.46 1.29 0 2.31-.3 3.05-.89.74-.6 1.11-1.43 1.11-2.49 0-.59-.1-1.09-.29-1.48s-.44-.75-.76-1.01zM448.3 548.25c.28.25.43.6.43 1.06v4.6h2.11v-4.93c0-.62-.14-1.16-.41-1.61-.27-.45-.64-.8-1.1-1.04a3.31 3.31 0 00-1.55-.36c-.53 0-1.01.1-1.44.31-.44.2-.8.49-1.1.87-.26-.38-.59-.67-1.01-.87-.41-.2-.87-.31-1.36-.31-.89 0-1.62.28-2.18.84v-.68h-2.11v7.79h2.11v-4.6c0-.45.14-.8.43-1.06s.64-.38 1.06-.38c.42 0 .77.13 1.06.38s.43.6.43 1.06v4.6h2.11v-4.6c0-.45.14-.8.43-1.06s.64-.38 1.06-.38c.4-.01.75.12 1.03.37zM453.9 553.53c.56.35 1.2.53 1.91.53.46 0 .89-.08 1.27-.24.39-.16.71-.38.98-.66v.74h2.1v-7.79h-2.1v.74c-.27-.28-.6-.5-.99-.66s-.82-.24-1.28-.24c-.7 0-1.33.18-1.89.53s-1.01.84-1.34 1.46-.49 1.31-.49 2.07.16 1.45.49 2.06c.33.62.77 1.11 1.34 1.46zm.88-5.04c.37-.39.84-.59 1.42-.59.59 0 1.07.2 1.44.59.37.39.55.89.55 1.51s-.18 1.13-.55 1.52c-.37.39-.84.59-1.44.59-.58 0-1.05-.2-1.42-.59s-.55-.9-.55-1.52c0-.61.18-1.11.55-1.51zM465 546.18c-.33.15-.62.36-.85.63v-.69h-2.11v7.79h2.11v-4.3c0-.58.14-1.01.42-1.3.28-.28.65-.43 1.11-.43.41 0 .74.13 1 .39l1.32-1.52c-.47-.53-1.09-.79-1.84-.79-.44-.01-.83.07-1.16.22z"
          className="st1"
        ></path>
        <path
          d="M472.06 542.88L469.95 542.88 469.95 546.12 468.13 546.12 468.13 547.97 469.95 547.97 469.95 553.9 472.06 553.9 472.06 547.97 473.89 547.97 473.89 546.12 472.06 546.12z"
          className="st1"
        ></path>
        <path
          d="M485.33 551.74c-.45.19-.99.29-1.63.29-.7 0-1.32-.16-1.85-.48-.54-.32-.96-.76-1.27-1.33-.31-.57-.46-1.24-.46-2 0-.75.15-1.41.46-1.98.31-.57.73-1.01 1.27-1.33.54-.32 1.16-.48 1.85-.48.59 0 1.11.1 1.56.29s.84.46 1.16.81l1.48-1.48c-.53-.5-1.13-.91-1.82-1.21-.69-.3-1.48-.45-2.39-.45-.84 0-1.61.15-2.32.45-.71.3-1.33.72-1.85 1.25s-.93 1.15-1.22 1.85-.44 1.46-.44 2.28c0 .83.15 1.59.44 2.3s.7 1.32 1.22 1.85 1.14.95 1.85 1.24c.71.3 1.48.44 2.32.44.92 0 1.74-.15 2.43-.44.7-.3 1.31-.7 1.84-1.22l-1.48-1.48c-.31.37-.7.64-1.15.83zM498.51 544.08a5.66 5.66 0 00-1.87-1.24 6.09 6.09 0 00-2.31-.44c-.83 0-1.6.15-2.31.44-.71.3-1.33.71-1.86 1.24s-.95 1.15-1.24 1.85a5.9 5.9 0 00-.44 2.28c0 .83.15 1.6.45 2.31.3.71.72 1.33 1.26 1.86s1.16.95 1.87 1.25c.71.3 1.48.45 2.31.45.83 0 1.59-.15 2.3-.45a5.869 5.869 0 003.1-3.1c.3-.7.45-1.47.45-2.3 0-.82-.15-1.58-.45-2.29-.31-.71-.72-1.33-1.26-1.86zm-1.01 6.14a3.35 3.35 0 01-1.27 1.34c-.54.32-1.17.48-1.89.48-.71 0-1.34-.16-1.88-.48-.54-.32-.97-.76-1.27-1.34-.31-.57-.46-1.24-.46-2.01 0-.74.15-1.4.46-1.97.31-.57.73-1.02 1.27-1.34s1.17-.48 1.88-.48c.72 0 1.35.16 1.89.48s.97.77 1.27 1.34c.31.57.46 1.23.46 1.97 0 .76-.16 1.43-.46 2.01zM510.58 544.17c-.53-.51-1.16-.91-1.87-1.19-.72-.28-1.49-.42-2.33-.42h-4.42v11.33h4.45c.84 0 1.61-.14 2.31-.42s1.32-.67 1.85-1.19.95-1.11 1.24-1.81.44-1.45.44-2.27c0-.82-.15-1.57-.44-2.26-.29-.66-.7-1.26-1.23-1.77zm-1.04 6.02c-.31.56-.73.99-1.28 1.3-.55.31-1.19.46-1.92.46h-2.19v-7.43h2.19c.72 0 1.35.15 1.9.46s.98.74 1.29 1.29.47 1.2.47 1.94c0 .76-.15 1.43-.46 1.98zM436.02 564.34c-.32-.26-.67-.47-1.05-.65s-.76-.32-1.14-.44c-.38-.12-.73-.25-1.05-.39a2.63 2.63 0 01-.77-.5c-.19-.19-.29-.45-.29-.76 0-.37.14-.65.43-.84.28-.19.68-.29 1.2-.29.44 0 .84.09 1.18.26.35.17.69.44 1.02.81l1.45-1.45c-.4-.46-.91-.84-1.53-1.13-.62-.29-1.32-.44-2.1-.44-.73 0-1.39.13-1.97.4-.58.26-1.04.64-1.37 1.12-.33.48-.5 1.06-.5 1.74 0 .58.1 1.06.29 1.44.19.38.45.69.77.94.32.24.67.44 1.05.6.38.16.76.31 1.14.44s.73.27 1.05.41c.32.14.58.33.77.54s.29.49.29.84c0 .4-.17.71-.51.94-.34.23-.79.34-1.36.34-.65 0-1.19-.12-1.62-.36-.44-.24-.82-.58-1.15-1.02l-1.45 1.45c.53.63 1.11 1.1 1.76 1.41.65.31 1.43.46 2.35.46 1.29 0 2.31-.3 3.05-.89.74-.6 1.11-1.43 1.11-2.49 0-.59-.1-1.09-.29-1.48s-.44-.76-.76-1.01zM443.3 566.71c0 .49-.12.87-.37 1.14-.25.26-.59.39-1.03.39-.44 0-.79-.13-1.03-.4s-.37-.65-.37-1.13v-4.47h-2.13v4.51c0 .68.15 1.27.45 1.79s.72.92 1.25 1.21c.53.29 1.14.44 1.83.44.69 0 1.3-.14 1.83-.43s.95-.69 1.24-1.2c.3-.52.44-1.12.44-1.81v-4.51h-2.11v4.47zM448.15 558.56c-.34 0-.63.12-.85.35s-.34.52-.34.85c0 .34.11.63.34.86.23.23.51.35.85.35.34 0 .63-.12.85-.35.23-.23.34-.52.34-.86 0-.33-.11-.62-.34-.85-.22-.23-.5-.35-.85-.35z"
          className="st1"
        ></path>
        <path
          d="M447.09 562.24H449.21999999999997V570.03H447.09z"
          className="st1"
        ></path>
        <path
          d="M454.34 559L452.23 559 452.23 562.24 450.41 562.24 450.41 564.09 452.23 564.09 452.23 570.03 454.34 570.03 454.34 564.09 456.17 564.09 456.17 562.24 454.34 562.24z"
          className="st1"
        ></path>
        <path
          d="M462.72 562.57c-.58-.34-1.23-.51-1.98-.51a4.084 4.084 0 00-3.56 2c-.36.61-.54 1.3-.54 2.06 0 .79.18 1.48.55 2.1.37.61.87 1.09 1.51 1.44.64.35 1.37.52 2.19.52.63 0 1.22-.11 1.76-.33.54-.22 1-.56 1.39-1.01l-1.24-1.24c-.24.27-.52.47-.85.61-.33.13-.69.2-1.07.2-.54 0-.99-.13-1.35-.4s-.61-.64-.74-1.13l5.69-.02c.08-.34.11-.65.11-.92 0-.74-.17-1.41-.5-1.99s-.8-1.04-1.37-1.38zm-3.94 2.73c.13-.46.36-.82.7-1.09s.76-.4 1.27-.4c.99 0 1.59.5 1.81 1.48h-3.78z"
          className="st1"
        ></path>
        <path
          d="M404.28 550.24L404.03 550.1 404.28 550.24z"
          className="st27"
        ></path>
        <path
          d="M374.78 538.89L374.78 538.89 374.82 538.86 374.8 538.87 364.95 544.56 389.53 558.75 399.15 553.2 374.57 539.01z"
          className="st27"
        ></path>
        <path
          d="M389.53 530.37L376.86 537.69 379.7 536.05 404.28 550.24 414.11 544.56z"
          className="st27"
        ></path>
        <path
          d="M388.78 580.3l-.06.31c-.02.11-.07.21-.12.31l.94.54V578c-.44.69-.71 1.48-.76 2.3zM388.76 571.17c.23-.4.49-.78.77-1.15v-11.26l-24.58-14.19v22.71l21.91 12.65c-.09-2.52.23-5.9 1.9-8.76z"
          className="st23"
        ></path>
        <path
          d="M389.53 581.47L389.53 578 389.53 578 389.53 581.46 389.53 581.47 398.94 576.04 398.94 576.03z"
          className="st35"
        ></path>
        <path
          d="M389.53 570.02L389.53 558.76 389.53 570.02z"
          className="st35"
        ></path>
        <path
          d="M398.94 575.73v-.84c-.97.02-1.84.07-2.62.15v.19c-.01.06-.07.11-.13.11-.02 0-.03 0-.05-.01-.02-.01-.03-.02-.04-.03-.01-.01-.02-.03-.03-.04-.01-.02-.01-.03-.01-.05v-.13c-1.12.12-2.05.3-2.83.51v.9c.01.32-.13.63-.37.83-.06.03-.12.04-.19.04-.05 0-.1-.01-.15-.03a.343.343 0 01-.16-.32v-.36c0-.07.05-.13.12-.13h.01c.07 0 .13.06.13.13v.36a.11.11 0 000 .08h.09c.17-.15.26-.37.25-.6v-.81c-1.22.37-2.05.83-2.61 1.31-.15.14-.27.3-.4.46l.07 3.15 8.92-4.87zM404.28 550.24l-.01 4.31-.15-.03v.34l-.52-.1-.46.68-.53-.11-.45.67-.53-.1-.46.67-.53-.11-.46.68-.53-.11-.45.67v-.15l-.06.09v-4.44l-9.62 5.56.24 10.98c1.86-2.27 4.76-3.92 9.17-4.12v-3.73c0-.4.25-.75.62-.88s.79 0 1.03.31l6.5 8.35c.26.34.26.8 0 1.14l-.66.85 1.59-.86-1.66.96-.02.03 7.77-4.48v-22.73l-9.82 5.66z"
          className="st35"
        ></path>
        <path
          d="M399.22 557.55L399.22 553.39 399.37 553.3 399.37 553.08 404.07 550.37 399.37 553.08 374.78 538.89 374.57 539.01 399.15 553.2 399.15 553.2 399.15 553.2 399.15 557.64z"
          className="st36"
        ></path>
        <path
          d="M389.77 569.74l-.24-10.98v11.26c.08-.1.17-.19.24-.28z"
          className="st36"
        ></path>
        <path
          d="M408.02 570.79L406.43 571.65 406.36 571.75z"
          className="st36"
        ></path>
        <path
          d="M398.94 576.03v-.31l-8.93 4.85-.07-3.15c-.15.18-.29.37-.41.57v3.47l9.41-5.43z"
          className="st36"
        ></path>
        <path
          d="M396.06 575.25c.01.02.02.03.03.04.01.01.03.02.04.03.02.01.03.01.05.01.06 0 .12-.04.13-.11v-.19l-.26.03v.13c0 .03.01.04.01.06z"
          className="st37"
        ></path>
        <path
          d="M396.18 575.33L396.18 575.33 396.18 575.33z"
          className="st37"
        ></path>
        <path
          d="M392.71 577.06h-.09a.11.11 0 010-.08v-.36c0-.07-.06-.13-.13-.13h-.01c-.07 0-.13.06-.12.13v.36c-.01.13.05.25.16.32a.433.433 0 00.34-.01c.25-.2.39-.51.37-.83v-.9c-.09.03-.18.05-.26.08v.81a.8.8 0 01-.26.61z"
          className="st37"
        ></path>
        <path
          d="M374.78 538.89L399.37 553.08 404.07 550.37 399.37 553.08 399.37 553.3 404.13 550.55 404.13 554.52 404.28 554.55 404.28 550.24 404.28 550.24 404.28 550.24 404.03 550.1 379.7 536.38 374.82 538.86 374.78 538.89z"
          className="st38"
        ></path>
        <path
          d="M404.07 554.8L403.58 554.7 403.3 555.12 403.27 555.11 403.09 555.37 402.6 555.27 402.32 555.69 402.28 555.68 402.11 555.94 401.62 555.84 401.33 556.26 401.3 556.25 401.12 556.51 400.63 556.41 400.34 556.83 400.31 556.82 400.14 557.08 399.65 556.98 399.37 557.39 399.37 557.33 399.22 557.55 399.22 557.7 399.67 557.03 400.2 557.14 400.65 556.46 401.18 556.57 401.64 555.89 402.17 555.99 402.62 555.32 403.15 555.43 403.61 554.75 404.13 554.85 404.13 554.52 404.07 554.51z"
          className="st35"
        ></path>
        <path
          d="M404.07 554.8L403.58 554.7 403.3 555.12 403.27 555.11 403.09 555.37 402.6 555.27 402.32 555.69 402.28 555.68 402.11 555.94 401.62 555.84 401.33 556.26 401.3 556.25 401.12 556.51 400.63 556.41 400.34 556.83 400.31 556.82 400.14 557.08 399.65 556.98 399.37 557.39 399.37 557.33 399.22 557.55 399.22 557.7 399.67 557.03 400.2 557.14 400.65 556.46 401.18 556.57 401.64 555.89 402.17 555.99 402.62 555.32 403.15 555.43 403.61 554.75 404.13 554.85 404.13 554.52 404.07 554.51z"
          className="st39"
        ></path>
        <path
          d="M403.27 555.11L402.77 555.02 402.6 555.27 403.09 555.37z"
          className="st36"
        ></path>
        <path
          d="M403.27 555.11L402.77 555.02 402.6 555.27 403.09 555.37z"
          className="st39"
        ></path>
        <path
          d="M399.37 553.3L399.22 553.39 399.22 557.55 399.37 557.33z"
          className="st36"
        ></path>
        <path
          d="M399.37 553.3L399.22 553.39 399.22 557.55 399.37 557.33z"
          className="st39"
        ></path>
        <path
          d="M404.07 554.51L403.76 554.45 403.58 554.7 404.07 554.8z"
          className="st36"
        ></path>
        <path
          d="M404.07 554.51L403.76 554.45 403.58 554.7 404.07 554.8z"
          className="st39"
        ></path>
        <path
          d="M400.31 556.82L399.82 556.72 399.65 556.98 400.14 557.08z"
          className="st36"
        ></path>
        <path
          d="M400.31 556.82L399.82 556.72 399.65 556.98 400.14 557.08z"
          className="st39"
        ></path>
        <path
          d="M401.3 556.25L400.8 556.15 400.63 556.41 401.12 556.51z"
          className="st36"
        ></path>
        <path
          d="M401.3 556.25L400.8 556.15 400.63 556.41 401.12 556.51z"
          className="st39"
        ></path>
        <path
          d="M402.28 555.68L401.79 555.58 401.62 555.84 402.11 555.94z"
          className="st36"
        ></path>
        <path
          d="M402.28 555.68L401.79 555.58 401.62 555.84 402.11 555.94z"
          className="st39"
        ></path>
        <path
          d="M399.37 553.3L399.37 557.33 399.37 557.39 399.65 556.98 399.82 556.72 400.31 556.82 400.34 556.83 400.63 556.41 400.8 556.15 401.3 556.25 401.33 556.26 401.62 555.84 401.79 555.58 402.28 555.68 402.32 555.69 402.6 555.27 402.77 555.02 403.27 555.11 403.3 555.12 403.58 554.7 403.76 554.45 404.07 554.51 404.13 554.52 404.13 550.55z"
          className="st38"
        ></path>
        <path
          d="M399.37 553.3L399.37 557.33 399.37 557.39 399.65 556.98 399.82 556.72 400.31 556.82 400.34 556.83 400.63 556.41 400.8 556.15 401.3 556.25 401.33 556.26 401.62 555.84 401.79 555.58 402.28 555.68 402.32 555.69 402.6 555.27 402.77 555.02 403.27 555.11 403.3 555.12 403.58 554.7 403.76 554.45 404.07 554.51 404.13 554.52 404.13 550.55z"
          className="st39"
        ></path>
        <linearGradient
          x1="1.485"
          x2="1.693"
          y1="794.963"
          y2="794.777"
          gradientTransform="matrix(230.671 0 0 -88.753 0 71084.375)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0" stopColor="#1A4D88"></stop>
          <stop offset="1" stopColor="#161749"></stop>
        </linearGradient>
        <linearGradient
          id="SVGID_00000181071799914112523280000008166316106371497351_"
          x1="1.497"
          x2="2.276"
          y1="794.977"
          y2="794.281"
          gradientTransform="matrix(230.671 0 0 -88.753 0 71084.375)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0" stopColor="#1A4D88"></stop>
          <stop offset="1" stopColor="#161749"></stop>
        </linearGradient>
        <path
          fill="url(#SVGID_00000181071799914112523280000008166316106371497351_)"
          d="M374.78 538.89L374.8 538.87 376.86 537.69z"
        ></path>
        <path
          d="M374.78 538.89L374.8 538.87 376.86 537.69z"
          className="st41"
        ></path>
        <path
          d="M376.86 537.69L374.8 538.87 374.82 538.86 378.44 536.78 379.49 536.17 379.49 536.17 379.69 536.06 404.03 550.1 404.28 550.24 404.28 550.24 379.7 536.05z"
          className="st27"
        ></path>
        <path
          d="M376.86 537.69L374.8 538.87 374.82 538.86 378.44 536.78 379.49 536.17 379.49 536.17 379.69 536.06 404.03 550.1 404.28 550.24 404.28 550.24 379.7 536.05z"
          className="st41"
        ></path>
        <path
          d="M379.49 536.17L378.44 536.78 379.49 536.17z"
          className="st36"
        ></path>
        <path
          d="M379.49 536.17L378.44 536.78 379.49 536.17z"
          className="st41"
        ></path>
        <path
          d="M404.28 550.24L404.28 550.24 404.28 550.24z"
          className="st35"
        ></path>
        <path
          d="M404.28 550.24L404.28 550.24 404.28 550.24z"
          className="st41"
        ></path>
        <path
          d="M404.03 550.1L379.69 536.06 379.49 536.17 378.44 536.78 374.82 538.86 379.7 536.38z"
          className="st38"
        ></path>
        <path
          d="M404.03 550.1L379.69 536.06 379.49 536.17 378.44 536.78 374.82 538.86 379.7 536.38z"
          className="st41"
        ></path>
        <path
          d="M406.43 571.65l.66-.85a.93.93 0 000-1.14l-6.5-8.35c-.24-.31-.66-.44-1.03-.31a.93.93 0 00-.62.88v3.73c-4.4.2-7.3 1.84-9.17 4.12-.08.1-.17.19-.24.28-.28.37-.54.75-.77 1.15-1.67 2.87-1.99 6.24-1.9 8.75.01.2.01.4.02.58.03.42.34.78.76.85.39.07.76-.11.96-.43.06-.09.1-.19.12-.31l.06-.31c.05-.83.33-1.61.76-2.3.12-.2.26-.39.41-.57.13-.16.25-.32.4-.46.56-.48 1.39-.94 2.61-1.31.09-.03.17-.05.26-.08.78-.21 1.72-.39 2.83-.51l.26-.03c.78-.08 1.65-.13 2.62-.15v3.7c0 .29.13.56.36.73.4.31.99.24 1.3-.16l5.74-7.38.02-.03.08-.09z"
          className="st1"
        ></path>
      </g>
    )
  })
  
  const KwikChat =  React.forwardRef((props, ref:any)  => {
    return (
      <g {...props} ref={ref}>
        <linearGradient
          id="SVGID_00000093161947029493486210000003753976221962300548_"
          x1="0.327"
          x2="1.05"
          y1="798.392"
          y2="797.747"
          gradientTransform="matrix(205 0 0 -97 0 77814.945)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0" stopColor="#1A4D88"></stop>
          <stop offset="1" stopColor="#161749"></stop>
        </linearGradient>
        <path
          fill="url(#SVGID_00000093161947029493486210000003753976221962300548_)"
          d="M172.33 413.44c-.54 0-.98.18-1.31.55-.34.36-.51.83-.51 1.4 0 .58.17 1.05.51 1.41.34.36.78.54 1.31.54.55 0 .99-.18 1.33-.54.34-.36.51-.83.51-1.41 0-.57-.17-1.03-.51-1.4-.34-.37-.78-.55-1.33-.55z"
        ></path>
        <linearGradient
          id="SVGID_00000140711683855881117670000017152457581011754677_"
          x1="0.217"
          x2="0.94"
          y1="798.269"
          y2="797.624"
          gradientTransform="matrix(205 0 0 -97 0 77814.945)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0" stopColor="#1A4D88"></stop>
          <stop offset="1" stopColor="#161749"></stop>
        </linearGradient>
        <path
          fill="url(#SVGID_00000140711683855881117670000017152457581011754677_)"
          d="M187.59 377.15H46.36c-3.3 0-5.98 2.68-5.98 5.98v60.53c0 3.3 2.68 5.98 5.98 5.98h141.23c3.3 0 5.98-2.68 5.98-5.98v-60.53c0-3.3-2.68-5.98-5.98-5.98zm-96.67 7.17c1.6 0 2.9 1.3 2.91 2.91h-.19c0-1.5-1.22-2.72-2.72-2.72v-.19zm10.99 46.78l-4.02-2.38h-4.75v11.46c0 1.23-1 2.23-2.23 2.23H64.96c-1.23 0-2.23-1-2.23-2.23v-27.53l-3.14 1.86v-7.64c.01-1.78 1.4-3.21 3.14-3.34v-16.3c0-1.23 1-2.23 2.23-2.23h25.96c1.23 0 2.23 1 2.23 2.23v1.07h.49v-.06h.2v.06h4.06c2.21.01 4.01 1.8 4.02 4.01v9.1l-4.02-2.39h-4.75V418h4.75c2.21.01 4.01 1.79 4.02 4.01v9.09zM124.4 419l-4.32-5.19V419h-2.03v-10.51h2.03v4.75l4.2-4.75h2.54l-4.53 5.01 4.69 5.5h-2.58zm10.78 0h-1.42l-1.54-4.23-1.55 4.23h-1.4l-2.7-7.22h1.97l1.46 4.39 1.51-4.39h1.42l1.51 4.39 1.46-4.39h1.97l-2.69 7.22zm5.5 0h-1.97v-7.22h1.97V419zm-.2-8.71c-.21.21-.47.32-.79.32s-.58-.11-.79-.32c-.21-.21-.31-.48-.31-.8 0-.31.1-.57.31-.79.21-.22.47-.33.79-.33s.58.11.79.33c.21.22.31.48.31.79.01.32-.1.59-.31.8zm6.54 8.71l-2.65-3.51V419h-1.96v-10.8h1.96v6.9l2.63-3.32h2.26l-2.84 3.44 2.99 3.78h-2.39zm10.62-.26c-.65.27-1.4.41-2.26.41-.78 0-1.49-.14-2.15-.41-.66-.27-1.23-.66-1.71-1.15-.48-.49-.86-1.07-1.13-1.72s-.4-1.36-.4-2.13c0-.76.13-1.46.4-2.11s.65-1.23 1.13-1.72a5.23 5.23 0 011.71-1.16 5.46 5.46 0 012.15-.42c.84 0 1.57.14 2.21.42.64.28 1.2.65 1.69 1.12l-1.38 1.38c-.3-.32-.66-.57-1.08-.75-.42-.18-.9-.27-1.45-.27-.65 0-1.22.15-1.72.44-.5.29-.89.71-1.17 1.23s-.43 1.14-.43 1.84c0 .71.14 1.33.43 1.85s.67.94 1.17 1.23c.5.29 1.07.44 1.72.44.59 0 1.09-.09 1.51-.27.42-.18.78-.43 1.08-.76l1.38 1.38c-.48.48-1.05.85-1.7 1.13zm9.73.26h-1.96v-4.14c0-.43-.14-.78-.41-1.05-.27-.27-.62-.4-1.04-.4s-.76.13-1.04.4c-.27.27-.41.62-.41 1.05V419h-1.96v-10.8h1.96v4.26c.25-.26.55-.46.9-.61.35-.14.73-.22 1.15-.22.55 0 1.03.12 1.46.36.42.24.75.57.99.99.24.42.36.9.36 1.45V419zm8.64 0h-1.94v-.69c-.25.26-.55.46-.91.61-.36.15-.75.22-1.18.22-.66 0-1.25-.16-1.77-.49s-.94-.78-1.24-1.34c-.3-.57-.46-1.21-.46-1.91s.15-1.35.46-1.92c.3-.57.72-1.02 1.24-1.35.52-.33 1.11-.49 1.76-.49.43 0 .82.07 1.19.22s.67.35.92.61v-.69h1.94V419zm6.44-5.5h-1.69v5.5h-1.96v-5.5h-1.69v-1.72h1.69v-3h1.96v3h1.69v1.72z"
        ></path>
        <path
          d="M126.83 408.49L124.29 408.49 120.09 413.25 120.09 408.49 118.05 408.49 118.05 419 120.09 419 120.09 413.81 124.4 419 126.99 419 122.3 413.5z"
          className="st1"
        ></path>
        <path
          d="M134.43 416.18L132.92 411.78 131.5 411.78 129.99 416.18 128.53 411.78 126.56 411.78 129.26 419 130.67 419 132.22 414.77 133.76 419 135.18 419 137.87 411.78 135.9 411.78z"
          className="st1"
        ></path>
        <path d="M138.71 411.78H140.68V419H138.71z" className="st1"></path>
        <path
          d="M139.69 408.37c-.32 0-.58.11-.79.33-.21.22-.31.48-.31.79 0 .32.1.59.31.8.21.21.47.32.79.32s.58-.11.79-.32c.21-.21.31-.48.31-.8 0-.31-.1-.57-.31-.79-.2-.22-.47-.33-.79-.33z"
          className="st1"
        ></path>
        <path
          d="M149.26 411.78L147 411.78 144.37 415.1 144.37 408.2 142.41 408.2 142.41 419 144.37 419 144.37 415.49 147.02 419 149.41 419 146.42 415.22z"
          className="st1"
        ></path>
        <path
          d="M156.89 417c-.42.18-.92.27-1.51.27-.65 0-1.22-.15-1.72-.44-.5-.29-.89-.7-1.17-1.23s-.43-1.15-.43-1.85c0-.7.14-1.31.43-1.84s.67-.94 1.17-1.23c.5-.29 1.07-.44 1.72-.44.55 0 1.03.09 1.45.27.42.18.78.43 1.08.75l1.38-1.38c-.49-.47-1.05-.84-1.69-1.12-.64-.28-1.38-.42-2.21-.42-.78 0-1.49.14-2.15.42-.66.28-1.23.67-1.71 1.16-.48.49-.86 1.07-1.13 1.72s-.4 1.36-.4 2.11c0 .77.13 1.48.4 2.13s.65 1.23 1.13 1.72c.48.49 1.05.88 1.71 1.15.66.27 1.38.41 2.15.41.86 0 1.61-.14 2.26-.41.65-.27 1.22-.65 1.7-1.13l-1.38-1.38c-.3.32-.66.58-1.08.76zM166.02 411.99c-.42-.24-.91-.36-1.46-.36-.42 0-.8.07-1.15.22-.35.14-.65.35-.9.61v-4.26h-1.96V419h1.96v-4.14c0-.43.14-.78.41-1.05.27-.27.62-.4 1.04-.4s.76.13 1.04.4c.27.27.41.62.41 1.05V419h1.96v-4.57c0-.55-.12-1.03-.36-1.45-.24-.42-.57-.75-.99-.99zM174.06 412.47c-.25-.26-.56-.46-.92-.61s-.76-.22-1.19-.22c-.65 0-1.23.16-1.76.49-.52.33-.94.78-1.24 1.35-.3.57-.46 1.21-.46 1.92s.15 1.34.46 1.91c.3.57.72 1.02 1.24 1.34s1.11.49 1.77.49c.43 0 .82-.07 1.18-.22s.66-.35.91-.61v.69h1.94v-7.22h-1.94v.69zm-.4 4.33c-.34.36-.78.54-1.33.54-.54 0-.98-.18-1.31-.54-.34-.36-.51-.83-.51-1.41 0-.57.17-1.03.51-1.4.34-.36.78-.55 1.31-.55.55 0 .99.18 1.33.55.34.36.51.83.51 1.4s-.17 1.04-.51 1.41z"
          className="st1"
        ></path>
        <path
          d="M180.76 408.78L178.8 408.78 178.8 411.78 177.11 411.78 177.11 413.5 178.8 413.5 178.8 419 180.76 419 180.76 413.5 182.45 413.5 182.45 411.78 180.76 411.78z"
          className="st1"
        ></path>
        <path d="M93.64 388.23H93.84V388.29H93.64z" className="st23"></path>
        <path
          d="M93.64 387.23h.19c0-1.6-1.3-2.9-2.91-2.91v.19c1.5 0 2.72 1.22 2.72 2.72z"
          className="st23"
        ></path>
        <path d="M92.13 399.02H93.14V418H92.13z" className="st23"></path>
        <path
          d="M92.13 440.18c0 .76-.61 1.37-1.37 1.37H64.81c-.76 0-1.37-.61-1.37-1.37v-27.67h21.45a3.395 3.395 0 003.38-3.38v-2.25a3.395 3.395 0 00-3.38-3.38H63.43v-16.28c0-.76.61-1.37 1.37-1.37h11.83c.08.63.6 1.12 1.25 1.13.65 0 1.17-.49 1.25-1.13h11.63c.76 0 1.37.61 1.37 1.37v1.07h1.01v-1.07c0-1.23-1-2.23-2.23-2.23H64.96c-1.23 0-2.23 1-2.23 2.23v16.3a3.364 3.364 0 00-3.14 3.34v7.64l3.14-1.86v27.53c0 1.23 1 2.23 2.23 2.23h25.96c1.23 0 2.23-1 2.23-2.23v-11.46h-1.01v11.47zm-13.55-30.89h-3.91v-.56h3.91v.56zm-15.01-2.56h20.72v.56H63.57v-.56zm0 1.99h9.61v.56h-9.61v-.56z"
          className="st23"
        ></path>
        <path
          d="M71.77 399.02a4.033 4.033 0 01-4.02-4.02v-2.68c.01-2.22 1.8-4.01 4.02-4.02h20.36v-1.07c0-.76-.61-1.37-1.37-1.37H79.13c-.08.63-.6 1.13-1.25 1.13s-1.17-.5-1.25-1.13H64.8c-.76 0-1.37.62-1.37 1.37v16.28h21.45c1.86 0 3.37 1.51 3.38 3.38v2.25a3.395 3.395 0 01-3.38 3.38H63.43v27.67c0 .76.61 1.37 1.37 1.37h25.96c.76 0 1.37-.61 1.37-1.37v-11.46H71.77a4.02 4.02 0 01-4.02-4.02v-2.68c.01-2.22 1.8-4.01 4.02-4.02h20.37v-18.98H71.77zm-2.15 31.22h7.8c1.7.01 3.08 1.38 3.09 3.09v2.06a3.105 3.105 0 01-3.09 3.09h-7.8l-3.09 1.83v-6.97c.01-1.72 1.39-3.1 3.09-3.1z"
          className="st23"
        ></path>
        <path
          d="M71.77 399.02a4.033 4.033 0 01-4.02-4.02v-2.68c.01-2.22 1.8-4.01 4.02-4.02h20.36v-1.07c0-.76-.61-1.37-1.37-1.37H79.13c-.08.63-.6 1.13-1.25 1.13s-1.17-.5-1.25-1.13H64.8c-.76 0-1.37.62-1.37 1.37v16.28h21.45c1.86 0 3.37 1.51 3.38 3.38v2.25a3.395 3.395 0 01-3.38 3.38H63.43v27.67c0 .76.61 1.37 1.37 1.37h25.96c.76 0 1.37-.61 1.37-1.37v-11.46H71.77a4.02 4.02 0 01-4.02-4.02v-2.68c.01-2.22 1.8-4.01 4.02-4.02h20.37v-18.98H71.77zm-2.15 31.22h7.8c1.7.01 3.08 1.38 3.09 3.09v2.06a3.105 3.105 0 01-3.09 3.09h-7.8l-3.09 1.83v-6.97c.01-1.72 1.39-3.1 3.09-3.1z"
          className="st45"
        ></path>
        <path
          d="M71.77 388.3c-2.22.01-4.01 1.8-4.02 4.02V395c.01 2.22 1.8 4.01 4.02 4.02h26.12l4.02 2.39v-9.1c-.01-2.21-1.81-4-4.02-4.01H71.77zm25.39 6.88H77.23v-.67h19.93v.67zm0-3.04v.67H72.48v-.67h24.68z"
          className="st46"
        ></path>
        <path d="M72.48 392.14H97.16V392.81H72.48z" className="st1"></path>
        <path d="M77.23 394.51H97.16V395.18H77.23z" className="st1"></path>
        <path
          d="M63.57 406.73H84.28999999999999V407.29H63.57z"
          className="st23"
        ></path>
        <path
          d="M63.57 406.73H84.28999999999999V407.29H63.57z"
          className="st47"
        ></path>
        <path
          d="M63.57 408.72H73.18V409.28000000000003H63.57z"
          className="st23"
        ></path>
        <path
          d="M63.57 408.72H73.18V409.28000000000003H63.57z"
          className="st47"
        ></path>
        <path
          d="M74.68 408.72H78.59V409.28000000000003H74.68z"
          className="st23"
        ></path>
        <path
          d="M74.68 408.72H78.59V409.28000000000003H74.68z"
          className="st47"
        ></path>
        <path
          d="M97.89 417.99H71.77c-2.22.01-4.01 1.8-4.02 4.02v2.68c0 2.22 1.8 4.02 4.02 4.02H97.9l4.02 2.38V422c-.02-2.21-1.82-4-4.03-4.01zm-.73 6.89H77.23v-.67h19.93v.67zm0-2.37H72.48v-.67h24.68v.67z"
          className="st46"
        ></path>
        <path d="M72.48 421.84H97.16V422.51H72.48z" className="st1"></path>
        <path d="M77.23 424.21H97.16V424.88H77.23z" className="st1"></path>
        <path d="M69.62 430.24L69.62 430.24" className="st48"></path>
        <path
          d="M66.53 433.33v6.97l3.09-1.83h7.8c1.7-.01 3.08-1.38 3.09-3.09v-2.06a3.105 3.105 0 00-3.09-3.09h-7.8c-1.7.01-3.08 1.39-3.09 3.1zm9.22 1.22c.24 0 .47.1.64.26.17.17.26.4.26.64 0 .5-.4.9-.9.9s-.9-.4-.9-.9.41-.9.9-.9zm-2.74-1.84c.5 0 .91.41.91.91s-.41.91-.91.91-.91-.41-.91-.91.4-.91.91-.91zm-2.73.74c.5.01.9.41.9.9 0 .5-.4.9-.9.9s-.9-.4-.9-.9c0-.49.41-.9.9-.9z"
          className="st23"
        ></path>
        <path
          d="M70.28 435.26c.5 0 .9-.4.9-.9a.91.91 0 00-.9-.9c-.5 0-.9.4-.9.9 0 .49.41.9.9.9z"
          className="st1"
        ></path>
        <circle cx="73.01" cy="433.63" r="0.91" className="st1"></circle>
        <path
          d="M75.75 436.35c.5 0 .9-.4.9-.9a.9.9 0 00-.26-.64.9.9 0 00-.64-.26c-.5 0-.9.4-.9.9s.41.9.9.9z"
          className="st1"
        ></path>
      </g>
    )
  })
  
  const Arrow = React.forwardRef((props, ref:any)  => {
    return (
      <g {...props} ref={ref}>
      <linearGradient
        id="SVGID_00000177443536417658013000000014362077500593211838_"
        x1="383.362"
        x2="299.337"
        y1="459.012"
        y2="362.75"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0" stopColor="#1A4D88"></stop>
        <stop offset="0.135" stopColor="#164781"></stop>
        <stop offset="1" stopColor="#161749"></stop>
      </linearGradient>
      <path
        fill="url(#SVGID_00000177443536417658013000000014362077500593211838_)"
        d="M542.56 246.49l-77.93 34.74 24.27 6.43c-77.44 110.59-222.56 219.76-371.8 261.22 153.78-30.51 317.6-129.19 399.7-244.56l18.08 23.73 7.68-81.56z"
      ></path>
    </g>
    )
  })
  
  
  export default function AnimationBanner(props) {
  
    let svgBg = useRef(null);
    let checkoutCard = useRef(null);
    let arrowIcon = useRef(null);
    let smartCOD = useRef(null);
    let kwikChat = useRef(null);
  
    React.useEffect(() => {
        animate()
        // console.log("reAnimate : ",props.reAnimate)
    },[])
  
    const animate = () => {
      const tl = gsap.timeline();
      tl.fromTo(svgBg.current, {opacity: 0, y: 100}, {opacity: 1, y: 0});
      tl.fromTo(arrowIcon.current, {opacity: 0, x: -50, y: 50}, {opacity: 1, x: 0, y: 0});
      tl.fromTo(checkoutCard.current, {opacity: 0, x: 50}, {opacity: 1, x: 0});
      tl.fromTo(kwikChat.current, {opacity: 0, x: -50}, {opacity: 1, x: 0});
      tl.fromTo(smartCOD.current, {opacity: 0, y: 50}, {opacity: 1, y: 0});
      tl.fromTo('.card', {x: -3, duration: 1, repeat: -1, yoyo: true}, {x: 3, duration: 1, repeat: -1, yoyo: true});
    }
    
  
    return (
      <>
       <div className="banner-main">
          <svg version="1.1"
            xmlns="http://www.w3.org/2000/svg"
            xmlnsXlink="http://www.w3.org/1999/xlink"
            width="600"
            height="600"
            x="0px" y="0px"
            viewBox="0 0 550 600">
  
            <SVGBg ref={svgBg}/>
            <CheckoutCard ref={checkoutCard} />
            <SmartCOD ref={smartCOD}/>
            <KwikChat ref={kwikChat}/>
            <Arrow ref={arrowIcon}/>
          </svg>
        </div>
      </>
    )
  }
  
  